// TEST VERIFICATION - 8 JANVIER 2026 - SI VOUS VOYEZ CE TEXTE, LES MODIFICATIONS FONCTIONNENT!
import React, { useState, useEffect, useRef, useCallback, useMemo, Component, ErrorInfo, lazy, Suspense } from 'react';
interface SubproductSettings {
  [productId: string]: {
    [subproductName: string]: {
      visible: boolean;
      price?: number;
    };
  };
}

interface SpecificationSettings {
  [productId: string]: {
    [specId: string]: {
      visible: boolean;
    };
  };
}
import Lottie from 'lottie-web';
import { AnimationItem } from 'lottie-web';

import {
  MenuItem,
  CartItem,
  Order,
  AdminStats,
  LoginCredentials,
  StoreResponse,
  Category,
  Product,
} from './types';
import Flag from 'react-flagkit';
import { FixedSizeList as List } from 'react-window';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { menuItems as initialMenuItems } from './data/menu';
import { Cart } from './components/Cart';
// v5 perf: lazy load AdminDashboard (composant lourd, jamais utilisé par le client final)
const AdminDashboard = lazy(() =>
  import('./components/admin/AdminDashboard').then((m) => ({
    default: m.AdminDashboard,
  }))
);
import { LoginForm } from './components/admin/LoginForm';
import { BackgroundMedia } from './components/BackgroundMedia';
import { set, get } from 'idb-keyval';

import {
  loginStore,
  logoutStore,
  getCategories,
  getProducts,
  getStoreInfo,
} from './services/api';
import { getMedia } from './services/storage';
import { settingsStorage } from './services/settingsStorage';
import { preloadImage } from './imageCache';
import { useTouchOptimization } from './hooks/useTouchOptimization';
import { sortBySequenceNumber } from './utils/sortBySequence';
import { loadGlobalModifiers, GlobalModifiersMap } from './services/globalModifiersService';

import {
  Menu,
  ShoppingCart,
  AlertCircle,
  X,
  ArrowRight,
  ArrowLeft,
  Plus,
  Minus,
} from 'lucide-react';
import { useAutoCleanup } from './hooks/useAutoCleanup';
import { useTheme } from './hooks/useTheme';
import { useSettingsMigration } from './hooks/useSettingsMigration';
import ModernNotification from './components/ModernNotification';
import { useModernNotification } from './hooks/useModernNotification';
import { Intro } from './components/Intro'; // Ajustez le chemin selon votre structure
import ProfileMedia from './components/ProfileMedia';
// v5: option "menu sans média en haut" (mode compact plein écran)
import {
  getDisplayModeSettings,
  DEFAULT_DISPLAY_MODE,
  DISPLAY_MODE_EVENT,
  type DisplayModeSettings,
} from './services/displayModeSettings';
// v5 mode démo : admin verrouillé par code secret + connexion auto du store démo
import {
  DEMO_MODE,
  DEMO_STORE_EMAIL,
  DEMO_STORE_PASSWORD,
} from './services/demoMode';
// v5: Mode Rush — blocage temporaire des commandes
import RushBlockScreen from './components/RushBlockScreen';
import { useRushStatus } from './hooks/useRushStatus';
// v5: Modules store — blocage ADMIN du kiosk (distinct du Rush)
import ModuleDisabledScreen from './components/ModuleDisabledScreen';
import { useStoreModules } from './hooks/useStoreModules';
// v5: Happy Hour — remise automatique par catégorie
import HappyHourBanner from './components/HappyHourBanner';
import { useHappyHour } from './hooks/useHappyHour';
import {
  getEligibleProductIds,
  isProductEligible,
  getDiscountedPrice,
  computeEligibleAmount,
} from './services/happyHourApi';
// v5: design du popup de personnalisation produit
import {
  getSpecPopupDesign,
  DEFAULT_SPEC_DESIGN,
  RADIUS_CLASSES as SPEC_RADIUS,
  ENTER_ANIMATION_CLASSES as SPEC_ENTER_ANIM,
  isLightColor as isLightColorSpec,
  getOptionButtonStyles,
  type SpecPopupDesignSettings,
} from './services/specPopupDesignSettings';
// v5: indicateur de scroll
import { ScrollHint } from './components/ScrollHint';
import {
  getScrollHintSettings,
  DEFAULT_SCROLL_HINT_SETTINGS,
  type ScrollHintSettings,
} from './services/scrollHintSettings';
// Fonction pour stocker les images dans le cache local


// SVG placeholder
const PlaceholderSVG = () => (
  <svg
    fill="#f97316"
    height="40px"
    width="40px"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 60 60"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M18.35,20.805c0.195,0.195,0.451,0.293,0.707,0.293c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414
        c-1.015-1.016-1.015-2.668,0-3.684c0.87-0.87,1.35-2.026,1.35-3.256s-0.479-2.386-1.35-3.256c-0.391-0.391-1.023-0.391-1.414,0
        s-0.391,1.023,0,1.414c0.492,0.492,0.764,1.146,0.764,1.842s-0.271,1.35-0.764,1.842C16.555,16.088,16.555,19.01,18.35,20.805z"
      />
      <path
        d="M40.35,20.805c0.195,0.195,0.451,0.293,0.707,0.293c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414
        c-1.015-1.016-1.015-2.668,0-3.684c0.87-0.87,1.35-2.026,1.35-3.256s-0.479-2.386-1.35-3.256c-0.391-0.391-1.023-0.391-1.414,0
        s-0.391,1.023,0,1.414c0.492,0.492,0.764,1.146,0.764,1.842s-0.271,1.35-0.764,1.842C38.555,16.088,38.555,19.01,40.35,20.805z"
      />
      <path
        d="M29.35,14.805c0.195,0.195,0.451,0.293,0.707,0.293c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414
        c-1.015-1.016-1.015-2.668,0-3.684c0.87-0.87,1.35-2.026,1.35-3.256s-0.479-2.386-1.35-3.256c-0.391-0.391-1.023-0.391-1.414,0
        s-0.391,1.023,0,1.414c0.492,0.492,0.764,1.146,0.764,1.842s-0.271,1.35-0.764,1.842C27.555,10.088,27.555,13.01,29.35,14.805z"
      />
      <path
        d="M55.624,43.721C53.812,33.08,45.517,24.625,34.957,22.577c0.017-0.16,0.043-0.321,0.043-0.48c0-2.757-2.243-5-5-5
        s-5,2.243-5,5c0,0.159,0.025,0.32,0.043,0.48C14.483,24.625,6.188,33.08,4.376,43.721C2.286,44.904,0,46.645,0,48.598
        c0,5.085,15.512,8.5,30,8.5s30-3.415,30-8.5C60,46.645,57.714,44.904,55.624,43.721z M27.006,22.27
        C27.002,22.212,27,22.154,27,22.098c0-1.654,1.346-3,3-3s3,1.346,3,3c0,0.057-0.002,0.114-0.006,0.172
        c-0.047-0.005-0.094-0.007-0.140-0.012c-0.344-0.038-0.690-0.065-1.038-0.089c-0.128-0.009-0.255-0.022-0.383-0.029
        c-0.474-0.026-0.951-0.041-1.432-0.041s-0.958,0.015-1.432,0.041c-0.128,0.007-0.255,0.020-0.383,0.029
        c-0.348,0.024-0.694,0.052-1.038,0.089C27.100,22.263,27.053,22.264,27.006,22.27z M25.126,26.635
        c1.582-0.356,3.217-0.537,4.860-0.537c0.004,0,0.009,0,0.014,0c0.552,0,1,0.448,1,1.001c0,0.552-0.448,0.999-1,0.999h0
        c-0.004,0-0.009,0-0.013,0c-1.496,0-2.982,0.164-4.421,0.488c-0.074,0.017-0.148,0.024-0.221,0.024c-0.457,0-0.870-0.315-0.975-0.780
        C24.249,27.291,24.587,26.756,25.126,26.635z M19.150,28.997c0.476-0.281,1.088-0.124,1.370,0.351
        c0.282,0.476,0.125,1.089-0.351,1.370c-4.713,2.792-8.147,7.861-9.186,13.560c-0.088,0.482-0.509,0.820-0.983,0.820
        c-0.060,0-0.120-0.005-0.180-0.017c-0.543-0.099-0.904-0.619-0.805-1.163C10.158,37.658,13.947,32.080,19.150,28.997z M30,55.098
        c-17.096,0-28-4.269-28-6.500c0-0.383,0.474-1.227,2.064-2.328c-0.004,0.057-0.002,0.113-0.006,0.170C4.024,46.988,4,47.540,4,48.098
        v0.788l0.767,0.185c8.254,1.981,16.744,2.985,25.233,2.985s16.979-1.004,25.233-2.985L56,48.886v-0.788
        c0-0.558-0.024-1.109-0.058-1.658c-0.004-0.057-0.002-0.113-0.006-0.170C57.526,47.371,58,48.215,58,48.598
        C58,50.829,47.096,55.098,30,55.098z"
      />
    </g>
  </svg>
);
const mockOrders: Order[] = [
  {
    id: '1',
    items: [],
    total: 25.98,
    status: 'pending',
    createdAt: new Date(),
    updatedAt: new Date(),
  },
];

const mockStats: AdminStats = {
  totalOrders: 150,
  totalRevenue: 2500.5,
  averageOrderValue: 16.67,
  popularItems: [],
};

import { withTranslation, WithTranslation } from 'react-i18next';

// Définir les props du composant, incluant celles fournies par withTranslation
interface AppErrorBoundaryProps extends WithTranslation {
  children: React.ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

// Error Boundary Component
class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

componentDidCatch(error: Error, errorInfo: ErrorInfo) {
  // Error logged to boundary
}
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-center">
          <h1 className="text-2xl font-bold text-red-600">
            {this.props.t('Erreur')}
          </h1>
          <p>{this.props.t("Une erreur s'est produite")}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600"
          >
            {this.props.t('Recharger')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Envelopper le composant avec withTranslation pour lui donner accès à t
const WrappedAppErrorBoundary = withTranslation()(AppErrorBoundary);

function App() {
  const [cacheMode, setCacheMode] = useState<'original' | 'modified'>(
    'original'
  );
  const { t, i18n } = useTranslation();
  const [translationCache, setTranslationCache] = useState<{
    [key: string]: string;
  }>({});
  const [rawCurrency, setRawCurrency] = useState('€'); // Devise brute depuis l'API
  const [currency, setCurrency] = useState('€'); // Devise traduite
  const lastLanguageChangeRef = useRef(Date.now());
  const googleTranslateRef = useRef<HTMLDivElement | null>(null);

const { settings: cleanupSettings, saveSettings: saveCleanupSettings } = useAutoCleanup(t);
  const { settings: themeSettings, saveTheme } = useTheme();
  const { isMigrated, isLoading: isMigrationLoading } = useSettingsMigration();
  const notification = useModernNotification();
  const { touchSettings } = useTouchOptimization();
  const [rawCategories, setRawCategories] = useState<Category[]>([]);

  const [rawProducts, setRawProducts] = useState<Product[]>([]);

  const [productsCache, setProductsCache] = useState<{
    [categoryId: string]: Product[];
  }>({});
  const [forceRender, setForceRender] = useState(0);

  // v5 anti-race : catégorie DEMANDÉE en dernier par le client (mise à jour
  // immédiatement au clic, avant même que le state selectedCategory ne change).
  // Tout chargement asynchrone qui se termine pour une AUTRE catégorie est jeté.
  const activeCategoryRef = useRef<string>('');

  // Porte d'entrée UNIQUE pour afficher des produits : n'applique que si
  // `categoryId` est toujours la catégorie active, et ne re-rend pas si la
  // liste est identique (évite l'effet "les produits vibrent").
  const applyProductsFor = (categoryId: string, next: Product[], source: string): boolean => {
    if (!categoryId || categoryId !== activeCategoryRef.current) {
      console.log(`[applyProductsFor] Ignoré (${source}) : catégorie obsolète`, {
        categoryId,
        active: activeCategoryRef.current,
      });
      return false;
    }
    setProducts((prev) =>
      prev.length === next.length && JSON.stringify(prev) === JSON.stringify(next) ? prev : next
    );
    return true;
  };
  const [printSettings, setPrintSettings] = useState<
    'manual' | 'auto' | 'none'
  >('manual');

  useEffect(() => {
    const syncProductsCache = () => {
      const storedCache = localStorage.getItem('productsCache');
      if (storedCache) {
        try {
          const parsedCache = JSON.parse(storedCache);
          // Le cache en mémoire est toujours plus frais que localStorage :
          // on ne fait que compléter les catégories manquantes.
          setProductsCache((prev) => ({ ...parsedCache, ...prev }));
        } catch (error) {
          notification.showNotification({
            title: t('Erreur de cache'),
            message: t('Erreur lors du chargement du cache des produits'),
            type: 'error',
          });
        }
      }
    };

    syncProductsCache();
    window.addEventListener('storage', syncProductsCache);
    return () => window.removeEventListener('storage', syncProductsCache);
  }, [t]);

  useEffect(() => {
    try {
      const cached = localStorage.getItem('translationCache');
      if (cached) {
        setTranslationCache(JSON.parse(cached));
      }
    } catch (error) {
      notification.showNotification({
        title: t('Erreur de stockage'),
        message: t('Impossible charger cache traductions'),
        type: 'error',
      });
    }
  }, [t, notification]);

  const saveTranslationCache = () => {
    try {
      localStorage.setItem(
        'translationCache',
        JSON.stringify(translationCache)
      );
    } catch (error) {
      notification.showNotification({
        title: t('Erreur de stockage'),
        message: t('Impossible sauvegarder cache traductions'),
        type: 'error',
      });
    }
  };
const [isVibrating, setIsVibrating] = useState(false);
const [specError, setSpecError] = useState<string | null>(null);
  // Sélectionner l'API de traduction
  const [isTranslationEnabled, setIsTranslationEnabled] = useState<boolean>(true);
const [isMediaLoading, setIsMediaLoading] = useState<boolean>(false);

  const [baseLanguage, setBaseLanguage] = useState<string>('fr');
  const [googleApiKey, setGoogleApiKey] = useState<string>('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const stored = localStorage.getItem('isLoggedIn');
    return stored === 'true';
  });
  const [loginError, setLoginError] = useState<string>();
  const [storeData, setStoreData] = useState<StoreResponse | null>(() => {
    const stored = localStorage.getItem('storeData');
    return stored ? JSON.parse(stored) : null;
  });
  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [showCart, setShowCart] = useState(false);
  const [menuItems, setMenuItems] = useState(initialMenuItems);
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [editingCartItemId, setEditingCartItemId] = useState<string | null>(null);
  const [showSpecifications, setShowSpecifications] = useState(false);

  const [cartTimeoutSettings, setCartTimeoutSettings] = useState({
    inactivityTimeout: 60,
    cartWarningDuration: 10,
  });
  const [isWarningActive, setIsWarningActive] = useState(false);
  const [warningCountdown, setWarningCountdown] = useState(0);
  const lastActivityRef = useRef<number>(Date.now());

  // Ajoutez les fonctions de traduction ici
  const normalizeLanguage = (lang: string, useGoogle: boolean) => {
    const langMap: { [key: string]: string } = {
      fr: useGoogle ? 'fr' : 'fr-FR',
      en: useGoogle ? 'en' : 'en-US',
      ar: useGoogle ? 'ar' : 'ar-SA',
      es: useGoogle ? 'es' : 'es-ES',
      de: useGoogle ? 'de' : 'de-DE',
    };
    const normalized = langMap[lang] || (useGoogle ? 'en' : 'en-US');
    return normalized;
  };

  const translateText = async (
    text: string,
    targetLang: string
  ): Promise<string> => {
    if (typeof text !== 'string' || !text.trim()) {
      return typeof text === 'string' ? text : '';
    }

    const sourceLang = baseLanguage || 'fr';
    const normalizedLang = normalizeLanguage(targetLang, true);
    const cacheKey = `${text}:${sourceLang}:${normalizedLang}`;

    if (translationCache[cacheKey]) {
      return translationCache[cacheKey];
    }

    if (sourceLang === targetLang) {
      return text;
    }

    if (!googleApiKey) {
      return text;
    }

    try {
      const requestConfig = {
        url: 'https://translation.googleapis.com/language/translate/v2',
        method: 'POST',
        params: { key: googleApiKey },
        data: {
          q: text,
          source: sourceLang,
          target: normalizedLang,
          format: 'text',
        },
        headers: { 'Content-Type': 'application/json' },
      };

      console.log('Envoi à Google Translate:', {
        url: requestConfig.url,
        q: text,
        source: sourceLang,
        target: normalizedLang,
      });

      const response = await axios(requestConfig);
      const translatedText = response.data.data.translations[0].translatedText;
      if (!translatedText) {
        console.warn(
          'Réponse invalide de Google, retour du texte original:',
          response.data
        );
        return text;
      }

      console.log(`✅ Traduction réussie (Google) : ${translatedText}`);
      setTranslationCache((prev) => ({
        ...prev,
        [cacheKey]: translatedText,
      }));
      saveTranslationCache();
      return translatedText;
    } catch (error: any) {
      console.error('Erreur Google Translate:', {
        message: error.message,
        code: error.code,
        status: error.response?.status,
        data: error.response?.data,
      });

      let errorMessage = t('Erreur lors de la traduction');
      if (error.response?.status === 401) {
        console.error('Erreur 401 : Clé API Google invalide ou non autorisée.');
        errorMessage = t('Clé API Google invalide');
      } else if (error.response?.status === 403) {
        console.error('Erreur 403 : Quota dépassé ou API non activée.');
        errorMessage = t('Quota dépassé ou API non activée');
      }

      return text;
    }
  };
  // Charger les produits depuis le cache sélectionné
  const loadProducts = async (categoryId: string): Promise<Product[]> => {
    const cacheMode = localStorage.getItem('cacheMode') || 'original';
    const cacheKey =
      cacheMode === 'modified' ? 'modifiedProducts' : 'originalProducts';
    let products: Product[] = [];

    console.log(
      `[loadProducts] Chargement pour catégorie ${categoryId}, mode: ${cacheMode}, cacheKey: ${cacheKey}`
    );

    // Vérifier IndexedDB
    try {
      const cachedData = await get(`product_${categoryId}`);
      if (Array.isArray(cachedData)) {
        products = cachedData;
        console.log(
          `[loadProducts] Produits chargés depuis IndexedDB (product_${categoryId}): ${products.length}`
        );
      }
    } catch (error) {
      console.error(`[loadProducts] Erreur lecture IndexedDB:`, error);
    }

    // Vérifier cache global si vide
    if (!products.length) {
      try {
        const globalCache = await get(cacheKey);
        if (Array.isArray(globalCache)) {
          products = globalCache.filter(
            (p: Product) => p.categoryId === categoryId
          );
          console.log(
            `[loadProducts] Produits chargés depuis ${cacheKey}: ${products.length}`
          );
        }
      } catch (error) {
        console.error(`[loadProducts] Erreur lecture ${cacheKey}:`, error);
      }
    }

    if (products.length) {
      products = sortBySequenceNumber(products);
      setProductsCache((prev) => ({
        ...prev,
        [categoryId]: products,
      }));
      try {
        let storedCache: { [id: string]: Product[] } = {};
        try {
          storedCache = JSON.parse(localStorage.getItem('productsCache') || '{}');
        } catch {
          storedCache = {};
        }
        localStorage.setItem(
          'productsCache',
          JSON.stringify({ ...storedCache, [categoryId]: products })
        );
        console.log(
          `[loadProducts] productsCache mis à jour pour ${categoryId}`
        );
      } catch (error) {
        console.error('[loadProducts] Erreur sauvegarde productsCache:', error);
      }
    }

    return sortBySequenceNumber(products);
  };
  // v5 perf : signature du dernier préchargement (magasin + catégories). L'effet se
  // relançait à chaque nouvelle RÉFÉRENCE de rawCategories/storeData, même identiques,
  // et reparcourait toutes les catégories. Le préchargement est conservé (c'est lui qui
  // rend le passage entre catégories fluide) — on évite seulement de le refaire pour rien.
  const lastPreloadSignatureRef = useRef('');
  useEffect(() => {
    const preloadAllProducts = async () => {
      if (rawCategories.length > 0 && storeData?.store) {
        const signature = `${storeData.store._id}|${rawCategories
          .map((c) => `${c._id}:${(c.product_ids || []).join(',')}`)
          .join(';')}`;
        if (signature === lastPreloadSignatureRef.current) return;
        lastPreloadSignatureRef.current = signature;
        console.log(
          '[preloadAllProducts] Préchargement des produits pour toutes les catégories'
        );
        for (const category of rawCategories) {
          await fetchProducts(category._id, true);
        }
      }
    };
    preloadAllProducts();
  }, [rawCategories, storeData]);

  useEffect(() => {
    return () => {
      // Nettoyer les balises <link> de préchargement lors du changement de catégorie
      const links = document.querySelectorAll('link[rel="preload"]');
      links.forEach((link) => {
        if (link.dataset.url) {
          console.log('[cleanup] Suppression link preload:', link.dataset.url);
          link.remove();
        }
      });
    };
  }, [selectedCategory]);
  // Appliquer les paramètres admin aux produits
const applyClientSettings = (items: Product[] | undefined | null): Product[] => {
  let subproductSettings: SubproductSettings = {};
  let productSettings: { [productId: string]: { visible: boolean; price?: number } } = {};
  let subproductImages: { [key: string]: string } = {};
  let subproductAnimations: { [key: string]: string } = {};
  let productImages: { [key: string]: string } = {};
  let specificationSettings: SpecificationSettings = {};
  let categorySettings: { [categoryId: string]: { visible: boolean } } = {};
  let globalModifiers: GlobalModifiersMap = {};

  try {
    subproductSettings = JSON.parse(localStorage.getItem('subproductSettings') || '{}');
    productSettings = JSON.parse(localStorage.getItem('productSettings') || '{}');
    subproductImages = JSON.parse(localStorage.getItem('subproductImages') || '{}');
    subproductAnimations = JSON.parse(localStorage.getItem('subproductAnimations') || '{}');
    productImages = JSON.parse(localStorage.getItem('productImages') || '{}');
    specificationSettings = JSON.parse(localStorage.getItem('specificationSettings') || '{}');
    categorySettings = JSON.parse(localStorage.getItem('categorySettings') || '{}');
    globalModifiers = JSON.parse(localStorage.getItem('globalModifiers') || '{}');
  } catch (error) {
    console.error('[applyClientSettings] Erreur parsing JSON:', error);
    notification.showNotification({
      title: t('Erreur de cache'),
      message: t('Erreur lors du chargement des paramètres.'),
      type: 'error',
    });
  }

  console.log('[applyClientSettings] Paramètres appliqués:', {
    subproductSettings,
    productSettings,
    subproductImages,
    subproductAnimations,
    productImages,
    specificationSettings,
    categorySettings,
  });

  if (!Array.isArray(items) || items.length === 0) {
    console.warn('[applyClientSettings] Aucun produit fourni:', items);
    return [];
  }

  return sortBySequenceNumber(
    items
      .filter((item) => categorySettings[item.categoryId]?.visible ?? true)
      .filter((item) => productSettings[item._id]?.visible ?? true)
      .map((item) => {
      const updatedItem = {
        ...item,
        price: productSettings[item._id]?.price ?? item.price,
        image: productImages[item._id] ?? item.image,
      };

      if (!updatedItem.specifications || !Array.isArray(updatedItem.specifications)) {
        console.warn('[applyClientSettings] Spécifications manquantes ou invalides:', {
          productId: item._id,
          specifications: updatedItem.specifications,
        });
        return updatedItem;
      }

      return {
        ...updatedItem,
        specifications: sortBySequenceNumber(
          updatedItem.specifications
            .filter((spec) => specificationSettings[item._id]?.[spec._id]?.visible ?? true)
            .map((spec) => {
              if (!spec.list || !Array.isArray(spec.list)) {
                console.warn('[applyClientSettings] Liste d\'options manquante:', {
                  productId: item._id,
                  specId: spec._id,
                  specName: spec.name?.[0],
                });
                return { ...spec, list: [] };
              }

              return {
                ...spec,
                list: sortBySequenceNumber(
                  spec.list
                    .filter((option) => {
                      const optionName = option.name?.[0];
                      if (!optionName) {
                        console.warn('[applyClientSettings] Option sans nom:', {
                          productId: item._id,
                          specId: spec._id,
                          optionId: option._id,
                        });
                        return false;
                      }
                      const settings = subproductSettings[item._id]?.[optionName];
                      const globalModifier = globalModifiers[optionName];

                      if (settings?.visible !== undefined) {
                        return settings.visible;
                      }

                      if (globalModifier?.visible !== undefined) {
                        return globalModifier.visible;
                      }

                      return true;
                    })
                    .map((option) => {
                      const optionName = option.name?.[0];
                      const settings = subproductSettings[item._id]?.[optionName];
                      const imageKey = `${item._id}:${optionName}`;
                      const globalModifier = globalModifiers[optionName];

                      let finalImage = option.image ?? updatedItem.image;
                      let finalPrice = option.price ?? updatedItem.price ?? 0;

                      if (subproductImages[imageKey]) {
                        finalImage = subproductImages[imageKey];
                      } else if (globalModifier?.image) {
                        finalImage = globalModifier.image;
                      }

                      if (settings?.price !== undefined) {
                        finalPrice = settings.price;
                      } else if (globalModifier?.price !== undefined) {
                        finalPrice = globalModifier.price;
                      }

                      return {
                        ...option,
                        price: finalPrice,
                        image: finalImage,
                        animation: subproductAnimations[imageKey],
                      };
                    })
                ),
              };
            })
        ),
      };
    })
  );
};


  const translateField = async (
    field: string | string[],
    targetLang: string,
    context?: string,
    contextType?: 'category' | 'product'
  ): Promise<string | string[]> => {
    if (Array.isArray(field)) {
      return Promise.all(
        field.map(async (text) => {
          if (typeof text !== 'string') return '';
          if (context) {
            const prefix =
              contextType === 'category'
                ? `This is a ${context} category:`
                : `This is a ${context} product:`;
            const fullText = `${prefix} ${text}`;
            const translated = await translateText(fullText, targetLang);
            const translatedPrefix = await translateText(prefix, targetLang);
            if (translated.startsWith(translatedPrefix)) {
              return translated.slice(translatedPrefix.length).trim();
            }
            return translated;
          }
          return await translateText(text, targetLang);
        })
      );
    }
    if (context) {
      const prefix =
        contextType === 'category'
          ? `This is a ${context} category:`
          : `This is a ${context} product:`;
      const fullText = `${prefix} ${field}`;
      const translated = await translateText(fullText, targetLang);
      const translatedPrefix = await translateText(prefix, targetLang);
      if (translated.startsWith(translatedPrefix)) {
        return translated.slice(translatedPrefix.length).trim();
      }
      return translated;
    }
    return translateText(field, targetLang);
  };

  const translateObject = async (
    obj: any,
    targetLang: string,
    fields: string[]
  ): Promise<any> => {
    const translatedObj = { ...obj };
    for (const field of fields) {
      if (translatedObj[field] !== undefined && translatedObj[field] !== null) {
        translatedObj[field] = await translateField(
          translatedObj[field],
          targetLang
        );
      }
    }
    return translatedObj;
  };

  // Ajouter avant translateApiData
  String.prototype.hashCode = function () {
    let hash = 0;
    for (let i = 0; i < this.length; i++) {
      const char = this.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    return hash;
  };

  const translateApiData = async (
    data: any,
    targetLang: string
  ): Promise<any> => {
    console.log('[translateApiData] Début traduction:', { targetLang });

    if (targetLang === baseLanguage) {
      console.log(
        '[translateApiData] Langue cible de base, retour des données brutes'
      );
      return data;
    }

    // Générer une clé de cache unique
    const cacheKey = `${TRANSLATION_CACHE_PREFIX}${targetLang}_${JSON.stringify(
      data
    ).hashCode()}`;
    const cachedTranslation = localStorage.getItem(cacheKey);
    if (cachedTranslation) {
      try {
        console.log(
          '[translateApiData] Traduction trouvée dans localStorage:',
          { cacheKey }
        );
        return JSON.parse(cachedTranslation);
      } catch (error) {
        console.error(
          '[translateApiData] Erreur lecture cache traduction:',
          error
        );
      }
    }

    if (Array.isArray(data)) {
      const translated = await Promise.all(
        data.map((item) => translateApiData(item, targetLang))
      );
      try {
        setTranslationCacheEntry(cacheKey, JSON.stringify(translated));
        console.log('[translateApiData] Traduction sauvegardée:', { cacheKey });
      } catch (error) {
        console.error(
          '[translateApiData] Erreur sauvegarde traduction:',
          error
        );
      }
      return translated;
    }

    const fieldsToTranslate = data.specifications
      ? ['details', 'description']
      : ['details', 'description', 'name'];
    const translatedObj = { ...data };
    for (const field of fieldsToTranslate) {
      if (translatedObj[field] !== undefined && translatedObj[field] !== null) {
        translatedObj[field] = await translateField(
          translatedObj[field],
          targetLang
        );
      }
    }

    if (data.specifications && Array.isArray(data.specifications)) {
      translatedObj.specifications = await Promise.all(
        data.specifications.map(async (spec: any) => {
          const translatedSpec = { ...spec };
          translatedSpec.name = await translateField(
            spec.name || [''],
            targetLang
          );
          if (spec.list && Array.isArray(spec.list)) {
            translatedSpec.list = await Promise.all(
              spec.list.map(async (option: any) => {
                if (!option) return { name: [''] };
                const translatedOption = { ...option };
                translatedOption.name = await translateField(
                  option.name || [''],
                  targetLang
                );
                return translatedOption;
              })
            );
          }
          return translatedSpec;
        })
      );
    }

    try {
      setTranslationCacheEntry(cacheKey, JSON.stringify(translatedObj));
      console.log('[translateApiData] Traduction sauvegardée:', { cacheKey });
    } catch (error) {
      console.error('[translateApiData] Erreur sauvegarde traduction:', error);
    }
    return translatedObj;
  };

  const [selectedSpecifications, setSelectedSpecifications] = useState<{
    [specId: string]: string[];
  }>({});
  const [currentSpecificationIndex, setCurrentSpecificationIndex] = useState(0);
  const [language, setLanguage] = useState<string>('fr');
  const [profileSettings, setProfileSettings] = useState<{
    restaurantName: string;
    profileMedia: string[];
    mediaIsVideo: boolean[];
    restaurantLogo: string;
    logoPosition: 'before' | 'after';
    hideLogo?: boolean;
    hideName?: boolean;
  }>({
    restaurantName: '',
    profileMedia: [],
    mediaIsVideo: [],
    restaurantLogo: '',
    logoPosition: 'before',
    hideLogo: true,
    hideName: false,
  });

  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);

  // v5: option "menu sans média en haut" (mode compact plein écran)
  const [displayModeSettings, setDisplayModeSettings] = useState<DisplayModeSettings>(DEFAULT_DISPLAY_MODE);
  useEffect(() => {
    getDisplayModeSettings().then(setDisplayModeSettings);
    const handleUpdate = (e: Event) => {
      const detail = (e as CustomEvent).detail as DisplayModeSettings;
      if (detail) setDisplayModeSettings(detail);
    };
    window.addEventListener(DISPLAY_MODE_EVENT, handleUpdate);
    return () => window.removeEventListener(DISPLAY_MODE_EVENT, handleUpdate);
  }, []);
  const hideProfileMedia = displayModeSettings.hideProfileMedia;

  // Nom/logo affichés dans l'en-tête : réglages admin en priorité,
  // sinon repli sur les infos du magasin renvoyées par l'API (toujours dispo une fois connecté).
  const storeApiInfo = getStoreInfo() || storeData?.store;
  const customName = profileSettings.restaurantName?.trim() || '';
  // Texte par défaut "Nom de l'établissement" dans toutes les langues → jamais affiché tel quel
  const placeholderNames = [
    'Restaurant Name',
    ...Object.keys(i18n.store?.data || {}).map((lng) =>
      i18n.getResource(lng, 'translation', 'Restaurant Name')
    ),
  ];
  const isPlaceholderName = !customName || placeholderNames.includes(customName);
  // Option admin « Ne pas afficher le nom » (décochée par défaut) : aucun nom, ni perso ni API.
  const headerName = profileSettings.hideName
    ? ''
    : isPlaceholderName
    ? storeApiInfo?.name?.trim() || ''
    : customName;
  const apiLogo = storeApiInfo?.image_url
    ? /^(https?:|data:|blob:)/.test(storeApiInfo.image_url)
      ? storeApiInfo.image_url
      : `https://api.restomi.fr/${storeApiInfo.image_url.replace(/^\/+/, '')}`
    : '';
  // Option admin « Ne pas afficher le logo » (cochée par défaut) : aucun logo, ni perso ni API.
  const headerLogo = profileSettings.hideLogo !== false ? '' : profileSettings.restaurantLogo || apiLogo;

  // === v5: Média de profil personnalisé par catégorie ===
  // Mémorise le diaporama GLOBAL d'origine (jamais modifié par les swaps de catégorie)
  const originalProfileMediaRef = useRef<{
    profileMedia: string[];
    mediaIsVideo: boolean[];
  }>({ profileMedia: [], mediaIsVideo: [] });

  // Map { [categoryId]: { url, isVideo } } chargée depuis IndexedDB
  const [categoryProfileMediaMap, setCategoryProfileMediaMap] = useState<{
    [categoryId: string]: { url: string; isVideo: boolean };
  }>({});

  // Indique si on affiche actuellement un média de catégorie (vs le diaporama global)
  const isShowingCategoryMediaRef = useRef<boolean>(false);

  // v5: timeout d'inactivité avant retour au diaporama principal (3 minutes)
  const CATEGORY_MEDIA_INACTIVITY_TIMEOUT_SEC = 180;
  // Track la catégorie dont le média a expiré par inactivité (pour réactivation à la retouche)
  const expiredCategoryIdRef = useRef<string | null>(null);
  // === fin v5 ===

  // v5: design personnalisable du popup de personnalisation produit
  const [specPopupDesign, setSpecPopupDesign] = useState<SpecPopupDesignSettings>(DEFAULT_SPEC_DESIGN);
  useEffect(() => {
    let mounted = true;
    getSpecPopupDesign().then((d) => {
      if (mounted) setSpecPopupDesign(d);
    });
    const onUpdate = (e: Event) => {
      const ce = e as CustomEvent<SpecPopupDesignSettings>;
      if (ce.detail) setSpecPopupDesign(ce.detail);
    };
    window.addEventListener('specPopupDesignUpdated', onUpdate);
    return () => {
      mounted = false;
      window.removeEventListener('specPopupDesignUpdated', onUpdate);
    };
  }, []);
  // === fin v5 spec popup design ===

  // v5: indicateurs de scroll (panier, catégories, produits)
  const [scrollHintSettings, setScrollHintSettings] = useState<ScrollHintSettings>(
    DEFAULT_SCROLL_HINT_SETTINGS
  );
  const categoriesScrollRef = useRef<HTMLElement>(null);
  const productsScrollRef = useRef<HTMLDivElement>(null);
  const cartScrollRef = useRef<HTMLElement>(null);

  useEffect(() => {
    let mounted = true;
    getScrollHintSettings().then((s) => {
      if (mounted) setScrollHintSettings(s);
    });
    const onUpdate = (e: Event) => {
      const ce = e as CustomEvent<ScrollHintSettings>;
      if (ce.detail) setScrollHintSettings(ce.detail);
    };
    window.addEventListener('scrollHintSettingsUpdated', onUpdate);
    return () => {
      mounted = false;
      window.removeEventListener('scrollHintSettingsUpdated', onUpdate);
    };
  }, []);
  // === fin v5 scroll hint ===

  const [subproductImages, setSubproductImages] = useState<{
    [key: string]: string;
  }>({});

 const hasLoadedSettings = useRef(false);
  const [productImages, setProductImages] = useState<{
  [key: string]: string;
}>({});
  const [categoryImages, setCategoryImages] = useState<{
  [categoryId: string]: string;
}>({});

  // === v5 perf: chargement async des images en arrière-plan, sans bloquer le render ===
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [sub, prod, cat] = await Promise.all([
          get('subproductImages'),
          get('productImages'),
          get('categoryImages'),
        ]);
        if (!mounted) return;
        if (sub) setSubproductImages(sub as any);
        if (prod) setProductImages(prod as any);
        if (cat) setCategoryImages(cat as any);
      } catch (e) {
        console.error('[App] Erreur chargement images caches:', e);
      }
    })();
    return () => { mounted = false; };
  }, []);
  // === fin v5 perf ===
  const imageCache = useRef<{ [key: string]: string }>({}).current;

const cacheImage = useCallback(
  (url: string, id?: string, type: 'product' | 'category' = 'product'): string => {
    if (!url) return '';

    // Si une image personnalisée existe pour cet ID, la retourner directement
    if (id) {
      if (type === 'category' && categoryImages && categoryImages[id]) {
        console.log('[cacheImage] Image personnalisée de catégorie utilisée:', id);
        return categoryImages[id];
      }
      if (type === 'product' && productImages && productImages[id]) {
        console.log('[cacheImage] Image personnalisée de produit utilisée:', id);
        return productImages[id];
      }
    }

    const thumbnailUrl = `${url}?size=thumbnail`;
    if (imageCache[thumbnailUrl]) {
      console.log('[cacheImage] Image déjà en cache:', thumbnailUrl);
      return imageCache[thumbnailUrl];
    }
    imageCache[thumbnailUrl] = thumbnailUrl;

    // Précharger toutes les images
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = thumbnailUrl;
    link.dataset.url = thumbnailUrl; // Pour débogage et nettoyage
    document.head.appendChild(link);

    const img = new Image();
    img.src = thumbnailUrl;
    img.loading = 'lazy';
    img.onload = () => {
      console.log('[cacheImage] Image préchargée:', thumbnailUrl);
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
    img.onerror = () => {
      console.error('[cacheImage] Erreur préchargement:', thumbnailUrl);
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };

    return thumbnailUrl;
  },
  [categoryImages, productImages]
);
useEffect(() => {
  if (hasLoadedSettings.current) return;

  const loadCategorySettings = async () => {
    try {
      const storedCategorySettings = (await get('categorySettings')) || {};
      setCategorySettings((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(storedCategorySettings)) {
          return prev;
        }
        console.log('[App] categorySettings chargé:', storedCategorySettings);
        return storedCategorySettings;
      });

      const storedGlobalModifiers = await loadGlobalModifiers();
      setGlobalModifiers((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(storedGlobalModifiers)) {
          return prev;
        }
        console.log('[App] globalModifiers chargé:', storedGlobalModifiers);
        return storedGlobalModifiers;
      });

      hasLoadedSettings.current = true;
    } catch (error) {
      console.error('[App] Erreur chargement categorySettings:', error);
      notification.showNotification({
        title: t('Erreur de cache'),
        message: t('Impossible de charger les paramètres des catégories.'),
        type: 'error',
      });
    }
  };
  loadCategorySettings();
}, [t, notification, storeData]);

  
  const [subproductAnimations, setSubproductAnimations] = useState<{
    [key: string]: string;
  }>({});
  const [subproductSettings, setSubproductSettings] =
    useState<SubproductSettings>({});
  const [specificationSettings, setSpecificationSettings] =
    useState<SpecificationSettings>({});
  const [productSettings, setProductSettings] = useState<{
    [productId: string]: { visible: boolean; price?: number };
  }>({});
  const [categorySettings, setCategorySettings] = useState<{
    [categoryId: string]: { visible: boolean };
  }>({});
  const [globalModifiers, setGlobalModifiers] = useState<GlobalModifiersMap>({});
  const lottieRefs = useRef<{ [key: string]: AnimationItem | null }>({});

  // === v5 perf: chargement async des settings en arrière-plan ===
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [sa, ss, ssp, ps] = await Promise.all([
          get('subproductAnimations'),
          get('subproductSettings'),
          get('specificationSettings'),
          get('productSettings'),
        ]);
        if (!mounted) return;
        if (sa) setSubproductAnimations(sa as any);
        if (ss) setSubproductSettings(ss as any);
        if (ssp) setSpecificationSettings(ssp as any);
        if (ps) setProductSettings(ps as any);
      } catch (e) {
        console.error('[App] Erreur chargement settings produits:', e);
      }
    })();
    return () => { mounted = false; };
  }, []);
  // === fin v5 perf ===

  // Optimisation: Pause/Play Lottie selon visibilité popup et onglet
  useEffect(() => {
    const handleVisibilityChange = () => {
      const isVisible = !document.hidden && showSpecifications;
      Object.values(lottieRefs.current).forEach((anim) => {
        if (anim) {
          if (isVisible) {
            anim.play();
          } else {
            anim.pause();
          }
        }
      });
    };

    // Gérer visibilité initiale
    handleVisibilityChange();

    // Écouter changements de visibilité de l'onglet
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [showSpecifications]);

useEffect(() => {
  const handleStorageChange = async () => {
    try {
      const images = (await get('subproductImages')) || {};
      setSubproductImages((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(images)) return prev;
        console.log('[App] subproductImages synchronisé:', images);
        return images;
      });

      const animations = (await get('subproductAnimations')) || {};
      setSubproductAnimations((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(animations)) return prev;
        console.log('[App] subproductAnimations synchronisé:', animations);
        return animations;
      });

      const productImagesData = (await get('productImages')) || {};
      setProductImages((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(productImagesData)) return prev;
        console.log('[App] productImages synchronisé:', productImagesData);
        return productImagesData;
      });

      const categoryImagesData = (await get('categoryImages')) || {};
      setCategoryImages((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(categoryImagesData)) return prev;
        console.log('[App] categoryImages synchronisé:', categoryImagesData);
        return categoryImagesData;
      });

      const settings = (await get('subproductSettings')) || {};
      setSubproductSettings((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(settings)) return prev;
        console.log('[App] subproductSettings synchronisé:', settings);
        return settings;
      });

      const globalMods = await loadGlobalModifiers();
      setGlobalModifiers((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(globalMods)) return prev;
        console.log('[App] globalModifiers synchronisé:', globalMods);
        return globalMods;
      });

      const specSettings = (await get('specificationSettings')) || {};
      setSpecificationSettings((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(specSettings)) return prev;
        console.log('[App] specificationSettings synchronisé:', specSettings);
        return specSettings;
      });

      const prodSettings = (await get('productSettings')) || {};
      setProductSettings((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(prodSettings)) return prev;
        console.log('[App] productSettings synchronisé:', prodSettings);
        return prodSettings;
      });

      const catSettings = (await get('categorySettings')) || {};
      setCategorySettings((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(catSettings)) return prev;
        console.log('[App] categorySettings synchronisé:', catSettings);
        return catSettings;
      });

      const translationEnabled = await settingsStorage.getTranslationEnabled();
      const baseLang = await settingsStorage.getBaseLanguage();
      const apiKey = await settingsStorage.getGoogleApiKey();
      const printSetting = await settingsStorage.getPrintSettings();

      setIsTranslationEnabled(translationEnabled);
      setBaseLanguage(baseLang);
      setGoogleApiKey(apiKey);
      setPrintSettings(printSetting);

      console.log('[App] Paramètres chargés depuis IndexedDB:', {
        isTranslationEnabled: translationEnabled,
        baseLanguage: baseLang,
        googleApiKey: apiKey ? '***' : '',
        printSettings: printSetting
      });
    } catch (error) {
      console.error('Erreur synchronisation storage:', error);
      notification.showNotification({
        title: t('Erreur de stockage'),
        message: t('Impossible synchroniser paramètres'),
        type: 'error',
      });
    }
  };

  window.addEventListener('storage', handleStorageChange);
  handleStorageChange();
  return () => window.removeEventListener('storage', handleStorageChange);
}, [t, notification]); 
  useEffect(() => {
  if (rawCategories.length > 0) {
    console.log('[useEffect] Mise à jour des catégories suite à changement de categoryImages');
    const applyUpdates = async () => {
      const cacheMode = localStorage.getItem('cacheMode') || 'original';
      let translatedCategories = rawCategories;
      if (cacheMode === 'modified') {
        translatedCategories = rawCategories.map((category) => ({
          ...category,
          image: categoryImages[category._id] ?? category.image_url,
        }));
      }
      if (isTranslationEnabled && googleApiKey && i18n.language !== baseLanguage) {
        translatedCategories = await translateApiData(translatedCategories, i18n.language);
      }
      const filteredCategories = translatedCategories.filter(
        (category) => categorySettings[category._id]?.visible ?? true
      );
      const sortedCategories = sortBySequenceNumber(filteredCategories);
      setCategories(sortedCategories);
      console.log('[useEffect] Catégories mises à jour après changement de categoryImages:', sortedCategories.length);
    };
    applyUpdates();
  }
}, [categoryImages, rawCategories, isTranslationEnabled, googleApiKey, i18n.language, baseLanguage, categorySettings]);

  const [isLoading, setIsLoading] = useState(true);
  const [isStandbyActive, setIsStandbyActive] = useState(false); 
  const [displayMode, setDisplayMode] = useState<
    'auto' | 'mobile' | 'desktop-2' | 'desktop-3'
  >(() => {
    const stored = localStorage.getItem('displayMode');
    return stored
      ? (stored as 'auto' | 'mobile' | 'desktop-2' | 'desktop-3')
      : 'auto';
  });
  const [error, setError] = useState<string | null>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const lastInteractionRef = useRef(Date.now());

  // v5 FIX course (race condition) chargement produits :
  // chaque changement de catégorie incrémente cet ID. À la fin d'un chargement
  // asynchrone, on n'applique les produits QUE si l'ID n'a pas changé entre-temps.
  // Sans ça, sur appareil/connexion lent, la réponse d'une ancienne catégorie
  // arrive après coup et écrase l'affichage de la catégorie courante
  // ("ça saute vers d'autres produits").
  const categoryRequestIdRef = useRef(0);
  // Filet de sécurité : si une catégorie est sélectionnée sans passer par
  // handleCategoryChange, la considérer comme active.
  useEffect(() => {
    if (selectedCategory && !activeCategoryRef.current) {
      activeCategoryRef.current = selectedCategory;
    }
  }, [selectedCategory]);
  const [showIntro, setShowIntro] = useState(true);

  // ============================================================
  // v5 — MODE RUSH : blocage temporaire des nouvelles commandes
  // ============================================================
  // Polling toutes les 30s. Désactivé en mode admin (le staff doit
  // toujours pouvoir accéder au panel même pendant un rush).
  const rush = useRushStatus({ enabled: !isAdmin });

  // RÈGLE MÉTIER : on ne bloque QUE les nouvelles commandes.
  // Si le client a déjà des articles dans son panier, on le laisse
  // terminer sa commande (pas de blocage brutal en pleine saisie).
  const hasItemsInCart = cartItems.length > 0;
  const shouldBlockForRush = rush.isActive && !hasItemsInCart && !isAdmin;

  useEffect(() => {
    if (rush.isActive && hasItemsInCart) {
      console.log(
        '[Rush] Rush actif mais panier non vide → le client peut terminer sa commande'
      );
    }
  }, [rush.isActive, hasItemsInCart]);

  // Si create_order est refusé pour cause de rush, Cart remonte le statut ici.
  const handleRushRejection = useCallback(
    (status: { active: boolean; remaining_seconds: number; message: string }) => {
      console.warn('[Rush] Commande refusée par le backend (rush_active)', status);
      rush.applyStatus(status);
    },
    [rush]
  );

  // ============================================================
  // v5 — MODULES STORE : blocage ADMIN du kiosk (abonnement, suspension)
  // ============================================================
  // ⚠️ À ne pas confondre avec le mode RUSH (pause temporaire du restaurateur).
  // FAIL-OPEN : erreur réseau → on ne bloque pas.
  // `ready: isLoggedIn` → on attend d'avoir le store_id avant d'appeler.
  const storeModules = useStoreModules({ enabled: !isAdmin, ready: isLoggedIn });

  // Si create_order est refusé pour module_disabled, Cart remonte le message ici.
  const handleModuleDisabled = useCallback(
    (description: string) => {
      storeModules.applyModuleDisabled(description);
    },
    [storeModules]
  );

  // ============================================================
  // v5 — HAPPY HOUR : remise automatique sur une catégorie
  // ============================================================
  // Polling 5 min + refresh au retour à l'accueil. Désactivé en mode admin.
  const happyHourState = useHappyHour({ enabled: !isAdmin });
  const activeHappyHour = happyHourState.happyHour;

  // Set des product_ids éligibles. null = tout le menu, Set vide = aucun.
  // Recalculé quand le happy hour ou les catégories changent.
  const eligibleProductIds = useMemo(
    () => getEligibleProductIds(activeHappyHour, categories || []),
    [activeHappyHour, categories]
  );

  // Somme des prix NORMAUX (avant remise) des articles éligibles du panier.
  // 0 si pas de happy hour → apply_happy_hour ne sera pas appelé.
  const happyHourEligibleAmount = useMemo(
    () => (activeHappyHour ? computeEligibleAmount(cartItems, eligibleProductIds) : 0),
    [activeHappyHour, cartItems, eligibleProductIds]
  );
  useEffect(() => {
    let isLoading = false; // Verrou pour éviter les appels concurrents

    const handleCacheModeChange = async () => {
      if (isLoading) {
        console.log('[handleCacheModeChange] Chargement en cours, ignoré');
        return;
      }
      isLoading = true;

      const newCacheMode = localStorage.getItem('cacheMode') || 'original';
      console.log('[App] cacheMode changé:', newCacheMode);

      // Toujours la catégorie active ACTUELLE (le state capturé ici peut être périmé)
      const categoryId = activeCategoryRef.current;
      if (!categoryId) {
        console.log('[handleCacheModeChange] Aucune catégorie sélectionnée');
        isLoading = false;
        return;
      }

      try {
        let categoryProducts = await loadProducts(categoryId);
        if (!categoryProducts.length) {
          categoryProducts = await fetchProducts(categoryId, true);
        }
        let modifiedProducts =
          newCacheMode === 'modified'
            ? applyClientSettings(categoryProducts)
            : categoryProducts;

        if (
          isTranslationEnabled &&
          googleApiKey &&
          i18n.language !== baseLanguage
        ) {
          modifiedProducts = await translateApiData(
            modifiedProducts,
            i18n.language
          );
        }

        applyProductsFor(categoryId, modifiedProducts, 'cacheModeChange');
      } catch (error) {
        console.error('[handleCacheModeChange] Erreur:', error);
        notification.showNotification({
          title: t('Erreur de traduction'),
          message: t('Échec de la traduction'),
          type: 'error',
        });
      } finally {
        isLoading = false;
      }
    };

    window.addEventListener('storage', handleCacheModeChange);
    return () => window.removeEventListener('storage', handleCacheModeChange);
  }, [isTranslationEnabled, googleApiKey, i18n.language, baseLanguage, t]);

  useEffect(() => {
    const checkLanguageInactivity = () => {
      const now = Date.now();
      const timeoutMs = 20 * 1000; // 20 secondes
      if (
        now - lastLanguageChangeRef.current >= timeoutMs &&
        i18n.language !== baseLanguage &&
        !isAdmin &&
        !isStandbyActive
      ) {
        console.log(
          '[checkLanguageInactivity] Retour à la langue par défaut:',
          {
            currentLanguage: i18n.language,
            baseLanguage,
          }
        );
        changeLanguage(baseLanguage);
        setLanguage(baseLanguage); // Synchroniser l'état language
      }
    };

    const interval = setInterval(checkLanguageInactivity, 1000);
    return () => clearInterval(interval);
  }, [baseLanguage, i18n.language, isAdmin, isStandbyActive]);

  useEffect(() => {
    const loadProfileFromIndexedDB = async () => {
      try {
        const profile = await settingsStorage.getProfileSettings();
        console.log('[App] Chargement du profil depuis IndexedDB:', {
          restaurantName: profile.restaurantName,
          siretMessage: profile.siretMessage,
          tvaMessage: profile.tvaMessage,
        });
        if (profile.restaurantName || profile.restaurantLogo) {
          setProfileSettings((prev) => ({
            ...prev,
            restaurantName: profile.restaurantName,
            restaurantLogo: profile.restaurantLogo || '',
            logoPosition: profile.logoPosition || 'before',
          }));
        }
        // Option « Ne pas afficher le logo » (masqué par défaut), appliquée dans tous les cas
        setProfileSettings((prev) => ({
          ...prev,
          hideLogo: profile.hideLogo ?? true,
          hideName: profile.hideName ?? false,
        }));
      } catch (error) {
        console.error('[App] Erreur lors du chargement du profil depuis IndexedDB:', error);
      }
    };

    loadProfileFromIndexedDB();
  }, []);

  useEffect(() => {
    const handleStorageUpdate = async () => {
      const profile = await settingsStorage.getProfileSettings();
      if (profile.restaurantName || profile.restaurantLogo) {
        setProfileSettings((prev) => ({
          ...prev,
          restaurantName: profile.restaurantName,
          restaurantLogo: profile.restaurantLogo || '',
          logoPosition: profile.logoPosition || 'before',
        }));
      }
      setProfileSettings((prev) => ({
          ...prev,
          hideLogo: profile.hideLogo ?? true,
          hideName: profile.hideName ?? false,
        }));
    };

    window.addEventListener('storage', handleStorageUpdate);
    return () => window.removeEventListener('storage', handleStorageUpdate);
  }, []);

  // Gestion du diaporama de profil
useEffect(() => {
  console.log(
    'Diaporama profil useEffect - profileMedia:',
    profileSettings.profileMedia,
    'currentMediaIndex:',
    currentMediaIndex
  );

  if (!profileSettings.profileMedia || profileSettings.profileMedia.length === 0) {
    console.log('Aucun média de profil disponible');
    return;
  }

  let interval: NodeJS.Timeout | null = null;
  // v5 perf : minuteur de relance vidéo, nettoyé avec l'effet (avant : il n'était jamais
  // arrêté et un nouveau s'ajoutait à chaque changement de média → centaines par jour).
  let keepPlaying: ReturnType<typeof setInterval> | null = null;
  let videoHandler: (() => void) | null = null;

  const advanceToNextMedia = () => {
    setCurrentMediaIndex((prev) => {
      const nextIndex = (prev + 1) % profileSettings.profileMedia.length;
      console.log(
        'Diaporama profil - Passage à l\'index:',
        nextIndex,
        'Média:',
        profileSettings.profileMedia[nextIndex]
      );
      return nextIndex;
    });
  };

  const setupMedia = () => {
    if (videoRef.current && videoHandler) {
      videoRef.current.removeEventListener('ended', videoHandler);
      videoHandler = null;
    }

    if (interval) {
      clearInterval(interval);
      interval = null;
    }

    if (profileSettings.mediaIsVideo[currentMediaIndex]) {
      if (videoRef.current) {
        videoRef.current.loop = profileSettings.profileMedia.length === 1;
        videoHandler = () => {
          console.log('Vidéo profil terminée, passage au média suivant');
          if (profileSettings.profileMedia.length > 1) {
            advanceToNextMedia();
          }
        };
        videoRef.current.addEventListener('ended', videoHandler);
        // Lancer la vidéo uniquement si l’écran de veille n’est pas actif
        if (!isStandbyActive) {
          videoRef.current.play().catch((err) => {
            console.error('Erreur lors de la lecture de la vidéo profil:', err);
            if (profileSettings.profileMedia.length > 1) {
              advanceToNextMedia();
            }
          });
        }
        // Relancer la vidéo uniquement après un délai raisonnable
        let lastPlayAttempt = 0;
        if (keepPlaying) clearInterval(keepPlaying);
        keepPlaying = setInterval(() => {
          const now = Date.now();
          if (
            !isStandbyActive &&
            videoRef.current &&
            videoRef.current.paused &&
            !videoRef.current.ended &&
            now - lastPlayAttempt > 2000 // Délai de 2 secondes
          ) {
            console.log('[ProfileVideo] Relance de la vidéo en pause', {
              isStandbyActive,
              paused: videoRef.current.paused,
            });
            lastPlayAttempt = now;
            videoRef.current.play().catch((err) => {
              if (err.name !== 'AbortError') {
                console.error('Erreur lors de la relance:', err);
              } else {
                console.log('[ProfileVideo] AbortError ignoré');
              }
            });
          }
        }, 2000); // Vérifier toutes les 2 secondes
      }
    } else {
      interval = setInterval(() => {
        console.log('Image profil - Temps écoulé, passage au média suivant');
        advanceToNextMedia();
      }, 5000);
    }
  };

  setupMedia();

  return () => {
    if (interval) clearInterval(interval);
    if (keepPlaying) clearInterval(keepPlaying);
    if (videoRef.current && videoHandler) {
      videoRef.current.removeEventListener('ended', videoHandler);
    }
  };
}, [profileSettings.profileMedia, currentMediaIndex, isStandbyActive]);

   

  const renderedProducts = React.useMemo(() => {
    console.log('[Rendu] Produits disponibles:', {
      total: products.length,
      inStock: products.filter((p) => p.is_item_in_stock).length,
      products: products.map((p) => ({
        id: p._id,
        name: p.name?.[0],
        inStock: p.is_item_in_stock,
      })),
    });
    return products;
  }, [products]);

  // Gestion de la détection mobile
  useEffect(() => {
    const updateDisplay = () => {
      if (displayMode === 'mobile') {
        setIsMobile(true);
      } else if (displayMode === 'desktop-2' || displayMode === 'desktop-3') {
        setIsMobile(false);
      } else {
        // Mode auto
        setIsMobile(window.innerWidth < 600);
      }
    };

    updateDisplay();
    window.addEventListener('resize', updateDisplay);
    return () => window.removeEventListener('resize', updateDisplay);
  }, [displayMode]);
  // Chargement des médias de profil
  useEffect(() => {
    // showLoading = false pour les mises à jour en direct depuis l'admin (pas d'écran de chargement)
    const loadProfileMedia = async (showLoading = true) => {
      if (showLoading) setIsLoading(true);
      try {
        const savedMedia = await getMedia('adminProfileMedia');
        console.log('getMedia(adminProfileMedia) returned:', savedMedia);
        let mediaArray: string[] = [];
        if (savedMedia) {
          if (Array.isArray(savedMedia)) {
            mediaArray = savedMedia;
          } else {
            try {
              mediaArray = JSON.parse(savedMedia);
              if (!Array.isArray(mediaArray)) {
                mediaArray = [savedMedia];
              }
            } catch {
              mediaArray = [savedMedia];
            }
          }
        }
        const validMedia = mediaArray.filter(
          (m): m is string =>
            typeof m === 'string' &&
            m.trim() !== '' &&
            !m.includes('[MEDIA_REFERENCE]')
        );
        console.log('validMedia:', validMedia);
        const mediaIsVideo = validMedia.map(
          (m) =>
            m.includes('.mp4') ||
            m.includes('.webm') ||
            m.startsWith('data:video') ||
            m.startsWith('blob:')
        );
        console.log('mediaIsVideo:', mediaIsVideo);
        // === v5: mémoriser le diaporama d'origine ===
        originalProfileMediaRef.current = {
          profileMedia: validMedia,
          mediaIsVideo,
        };
        // === fin v5 ===
        await handleProfileSettingsUpdate({
          profileMedia: validMedia,
          mediaIsVideo,
        });
        for (const media of validMedia) {
          const isVideo = mediaIsVideo[validMedia.indexOf(media)];
          if (isVideo) {
            try {
              const video = document.createElement('video');
              video.src = media;
              video.preload = 'auto';
              video.muted = true;
              video.playsInline = true;
              video.loop = false;
              await new Promise<void>((resolve, reject) => {
                video.oncanplaythrough = () => resolve();
                video.onerror = () =>
                  reject(
                    new Error(`Erreur de préchargement de la vidéo: ${media}`)
                  );
                video.load();
              });
              if (validMedia.indexOf(media) === 0) {
                videoRef.current = video;
              }
            } catch (err) {
              console.error('Erreur lors du préchargement:', err);
              notification.showNotification({
                title: t('Erreur'),
                message: t('Impossible précharger vidéo', { media }),
                type: 'error',
              });
            }
          }
        }
      } catch (error) {
        console.error('Erreur lors du chargement des médias:', error);
        notification.showNotification({
          title: t('Erreur'),
          message: t('Impossible charger médias'),
          type: 'error',
        });
      } finally {
        if (showLoading) setIsLoading(false);
      }
    };
    loadProfileMedia();

    // v5 : l'admin ajoute/supprime une photo ou vidéo du haut → l'écran client suit tout de suite
    // (avant, il fallait recharger la page pour voir le nouveau média)
    const onMediaListUpdated = () => loadProfileMedia(false);
    window.addEventListener('profileMediaListUpdated', onMediaListUpdated);
    return () => window.removeEventListener('profileMediaListUpdated', onMediaListUpdated);
  }, []);

  // ===========================================================================
  // v5 : Média de profil personnalisé par catégorie
  // ===========================================================================
  // 1) Chargement de la map { [categoryId]: { url, isVideo } } depuis IndexedDB
  useEffect(() => {
    const loadCategoryMediaMap = async () => {
      try {
        const raw = await getMedia('categoryProfileMedia');
        if (raw) {
          try {
            const parsed = JSON.parse(raw as string);
            if (parsed && typeof parsed === 'object') {
              setCategoryProfileMediaMap(parsed);
              console.log('[v5] categoryProfileMediaMap chargée:', Object.keys(parsed).length, 'entrées');
            }
          } catch (e) {
            console.error('[v5] Erreur parse categoryProfileMedia:', e);
          }
        }
      } catch (e) {
        console.error('[v5] Erreur chargement categoryProfileMedia:', e);
      }
    };
    loadCategoryMediaMap();

    // Recharger si l'admin met à jour les médias par catégorie
    const handleUpdate = (e: Event) => {
      const customEvent = e as CustomEvent;
      if (customEvent.detail && typeof customEvent.detail === 'object') {
        setCategoryProfileMediaMap(customEvent.detail);
        console.log('[v5] categoryProfileMediaMap mise à jour via event');
      } else {
        loadCategoryMediaMap();
      }
    };
    window.addEventListener('categoryProfileMediaUpdated', handleUpdate);
    return () => {
      window.removeEventListener('categoryProfileMediaUpdated', handleUpdate);
    };
  }, []);

  // 2) Swap automatique au changement de catégorie
  //    - Si la catégorie a un média perso → on bascule sur ce média
  //    - Sinon → on revient au diaporama global d'origine (intact)
  useEffect(() => {
    // Tant que le diaporama d'origine n'a pas été chargé, on ne fait rien
    if (originalProfileMediaRef.current.profileMedia.length === 0) {
      return;
    }

    const categoryEntry = selectedCategory
      ? categoryProfileMediaMap[selectedCategory]
      : null;

    if (categoryEntry && categoryEntry.url) {
      // → Cette catégorie a un média perso : on l'affiche
      console.log(
        '[v5] Swap → média catégorie:',
        selectedCategory,
        categoryEntry.isVideo ? '(vidéo)' : '(image)'
      );
      isShowingCategoryMediaRef.current = true;
      // Reset l'expiration : nouvelle catégorie = nouveau timer d'affichage
      expiredCategoryIdRef.current = null;
      // Reset l'activité pour avoir 3 min complètes à partir de ce moment
      lastActivityRef.current = Date.now();
      setProfileSettings((prev) => ({
        ...prev,
        profileMedia: [categoryEntry.url],
        mediaIsVideo: [categoryEntry.isVideo],
      }));
      setCurrentMediaIndex(0);
    } else if (isShowingCategoryMediaRef.current) {
      // → On était sur un média de catégorie, on revient au diaporama global
      console.log('[v5] Swap → retour au diaporama global');
      isShowingCategoryMediaRef.current = false;
      expiredCategoryIdRef.current = null;
      setProfileSettings((prev) => ({
        ...prev,
        profileMedia: originalProfileMediaRef.current.profileMedia,
        mediaIsVideo: originalProfileMediaRef.current.mediaIsVideo,
      }));
      setCurrentMediaIndex(0);
    }
    // Note : on n'appelle PAS handleProfileSettingsUpdate ici car ce sont
    // des changements temporaires d'affichage, pas des sauvegardes admin.
  }, [selectedCategory, categoryProfileMediaMap]);

  // 3) Timer d'inactivité : revenir au diaporama principal après 3 min d'inactivité
  //    même si une catégorie est toujours sélectionnée. On garde selectedCategory tel quel
  //    mais on force l'affichage du média principal.
  useEffect(() => {
    // Ne lancer le check que quand on affiche un média de catégorie
    if (!isShowingCategoryMediaRef.current) {
      return;
    }
    if (originalProfileMediaRef.current.profileMedia.length === 0) {
      return;
    }

    const checkInactivity = setInterval(() => {
      const timeSinceLastActivity =
        (Date.now() - lastActivityRef.current) / 1000;

      if (
        timeSinceLastActivity >= CATEGORY_MEDIA_INACTIVITY_TIMEOUT_SEC &&
        isShowingCategoryMediaRef.current
      ) {
        console.log(
          '[v5] Inactivité 3min atteinte → retour au diaporama principal (catégorie reste sélectionnée:',
          selectedCategory,
          ')'
        );
        // Mémoriser quelle catégorie vient d'expirer pour permettre la retouche réactive
        expiredCategoryIdRef.current = selectedCategory;
        isShowingCategoryMediaRef.current = false;
        setProfileSettings((prev) => ({
          ...prev,
          profileMedia: originalProfileMediaRef.current.profileMedia,
          mediaIsVideo: originalProfileMediaRef.current.mediaIsVideo,
        }));
        setCurrentMediaIndex(0);
      }
    }, 1000);

    return () => clearInterval(checkInactivity);
  }, [selectedCategory, profileSettings.profileMedia]);

  // 4) Réactivation : si le client retouche la même catégorie après expiration,
  //    re-afficher son média perso. On écoute touchstart/mousedown au niveau global
  //    et on vérifie si la catégorie active a un média ET vient d'expirer.
  useEffect(() => {
    const handleTouchReactivation = () => {
      // Si on n'est plus en mode "expiré", rien à faire
      if (!expiredCategoryIdRef.current) return;
      // Si la catégorie courante est celle qui vient d'expirer ET a un média
      if (
        selectedCategory &&
        selectedCategory === expiredCategoryIdRef.current
      ) {
        const entry = categoryProfileMediaMap[selectedCategory];
        if (entry && entry.url) {
          console.log(
            '[v5] Touche après expiration → réaffichage média catégorie:',
            selectedCategory
          );
          isShowingCategoryMediaRef.current = true;
          expiredCategoryIdRef.current = null;
          lastActivityRef.current = Date.now();
          setProfileSettings((prev) => ({
            ...prev,
            profileMedia: [entry.url],
            mediaIsVideo: [entry.isVideo],
          }));
          setCurrentMediaIndex(0);
        }
      }
    };

    window.addEventListener('touchstart', handleTouchReactivation);
    window.addEventListener('mousedown', handleTouchReactivation);
    return () => {
      window.removeEventListener('touchstart', handleTouchReactivation);
      window.removeEventListener('mousedown', handleTouchReactivation);
    };
  }, [selectedCategory, categoryProfileMediaMap]);
  // ===========================================================================
  // fin v5
  // ===========================================================================



  // Synchronisation des états avec localStorage
  useEffect(() => {
    try {
      localStorage.setItem('isLoggedIn', isLoggedIn.toString());
    } catch (error) {
      console.error('Erreur lors de la sauvegarde de isLoggedIn:', error);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (i18n.language !== language) {
      console.log('[useEffect] Synchronisation language:', {
        i18nLanguage: i18n.language,
        stateLanguage: language,
      });
      setLanguage(i18n.language);
      setForceRender((prev) => prev + 1);
    }
  }, [i18n.language, language]);

  useEffect(() => {
    if (storeData) {
      try {
        localStorage.setItem('storeData', JSON.stringify(storeData));
        fetchCategories();
      } catch (error) {
        console.error('Erreur lors de la sauvegarde de storeData:', error);
        notification.showNotification({
          title: t('Erreur de stockage'),
          message: t('Impossible sauvegarder données magasin'),
          type: 'error',
        });
      }
    } else {
      localStorage.removeItem('storeData');
    }
  }, [storeData]);

  useEffect(() => {
    if (
      selectedCategory &&
      storeData?.store &&
      !productsCache[selectedCategory]?.length
    ) {
      fetchProducts(selectedCategory);
    }
  }, [selectedCategory, storeData, productsCache]);

  const handleProfileSettingsUpdate = async (
    updates: Partial<{
      restaurantName: string;
      profileMedia: string[];
      mediaIsVideo: boolean[];
      restaurantLogo: string;
      logoPosition: 'before' | 'after';
    }>
  ) => {
    try {
      console.log('[App] Sauvegarde IMMEDIATE de profileSettings:', updates);

      // Sauvegarder dans IndexedDB uniquement si le nom/logo fait partie de la mise à jour
      // (sinon on risquerait d'écraser le profil avec une valeur périmée)
      const touchesProfile =
        'restaurantName' in updates || 'restaurantLogo' in updates || 'logoPosition' in updates;
      if (touchesProfile) {
        const currentSettings = await settingsStorage.getProfileSettings();
        const profileUpdates: Partial<typeof currentSettings> = {};
        if (updates.restaurantName && updates.restaurantName !== t('Restaurant Name')) {
          profileUpdates.restaurantName = updates.restaurantName;
        }
        if ('restaurantLogo' in updates) profileUpdates.restaurantLogo = updates.restaurantLogo || '';
        if (updates.logoPosition) profileUpdates.logoPosition = updates.logoPosition;
        await settingsStorage.saveProfileSettings({ ...currentSettings, ...profileUpdates });
        console.log('[App] Profil sauvegardé dans IndexedDB:', profileUpdates);
      }

      // Fusionner avec l'état le plus récent (évite d'écraser nom/logo chargés en parallèle)
      setProfileSettings((prev) => {
        const newSettings = { ...prev, ...updates };
        try {
          // Sauvegarder dans localStorage (version allégée)
          const lightweightSettings = {
            ...newSettings,
            profileMedia: newSettings.profileMedia.map((media) =>
              media.startsWith('data:') ? '[MEDIA_REFERENCE]' : media
            ),
          };
          localStorage.setItem('profileSettings', JSON.stringify(lightweightSettings));
        } catch (storageError) {
          console.error('[App] Erreur sauvegarde localStorage profileSettings:', storageError);
        }
        return newSettings;
      });

      notification.showNotification({
        title: t('Paramètres enregistrés'),
        message: t('Les paramètres du profil ont été mis à jour.'),
        type: 'success',
        duration: 3000,
      });
    } catch (error) {
      console.error('[App] ERREUR lors de la sauvegarde de profileSettings:', error);
      notification.showNotification({
        title: t('Erreur de stockage'),
        message: t('Espace stockage insuffisant'),
        type: 'error',
        duration: 5000,
      });
    }
  };

  // Dans App.tsx

const fetchCategories = async () => {
  if (!storeData?.store) {
    console.warn('[fetchCategories] storeData manquant:', storeData);
    return;
  }
  setIsLoading(true);
  setError(null);
  try {
    console.log('[fetchCategories] storeData:', {
      storeId: storeData.store._id,
      serverToken: storeData.store.server_token,
    });
    const maxRetries = 3;
    let retryCount = 0;
    let response = null;
    while (retryCount < maxRetries && !response?.success) {
      try {
        response = await getCategories(
          storeData.store._id,
          storeData.store.server_token
        );
        console.log('[fetchCategories] Réponse getCategories:', {
          success: response.success,
          product_groups: response.product_groups?.length,
          error: response.error,
        });
        if (!response.success || !response.product_groups?.length) {
          throw new Error('Aucune catégorie trouvée');
        }
      } catch (error) {
        retryCount++;
        console.warn(
          `[fetchCategories] Échec, tentative ${retryCount}/${maxRetries}:`,
          error
        );
        if (retryCount === maxRetries) throw error;
        await new Promise((resolve) =>
          setTimeout(resolve, 1000 * retryCount)
        );
      }
    }

    const sortedCategories = sortBySequenceNumber(response.product_groups);
    setRawCategories(sortedCategories);
    // Stocker les catégories dans IndexedDB
    try {
      await set('categories', sortedCategories);
      console.log(
        '[fetchCategories] Catégories sauvegardées dans IndexedDB:',
        {
          count: sortedCategories.length,
        }
      );
    } catch (error) {
      console.error('[fetchCategories] Erreur sauvegarde IndexedDB:', error);
    }

    // Charger categorySettings depuis localStorage pour garantir la dernière version
    let currentCategorySettings = categorySettings;
    try {
      const storedSettings = localStorage.getItem('categorySettings');
      if (storedSettings) {
        currentCategorySettings = JSON.parse(storedSettings);
        setCategorySettings(currentCategorySettings);
        console.log('[fetchCategories] categorySettings chargé depuis localStorage:', currentCategorySettings);
      }
    } catch (error) {
      console.error('[fetchCategories] Erreur lecture categorySettings:', error);
    }

    let translatedCategories = await translateApiData(
      sortedCategories,
      i18n.language
    );
    translatedCategories = translatedCategories.filter(
      (category: Category) => currentCategorySettings[category._id]?.visible ?? true
    );
    translatedCategories = sortBySequenceNumber(translatedCategories);
    setCategories(translatedCategories);

    // Forcer la mise à jour des produits pour refléter la visibilité des catégories
    // Catégorie active ACTUELLE (le state capturé ici peut être périmé et
    // ramènerait le client sur une ancienne catégorie)
    const currentCategory = activeCategoryRef.current || selectedCategory;
    if (currentCategory) {
      await handleCategoryChange(currentCategory, true);
    }
    console.log(
      '[fetchCategories] Catégories après filtrage:',
      translatedCategories.map((c) => c._id)
    );

    if (translatedCategories.length > 0 && !currentCategory) {
      activeCategoryRef.current = translatedCategories[0]._id;
      setSelectedCategory(translatedCategories[0]._id);
    }
    translatedCategories.forEach((category: Category) => {
      if (category.image_url) {
       cacheImage(`https://api.restomi.fr/${category.image_url}`, category._id, 'category');
      }
    });
  } catch (error) {
    console.error('[fetchCategories] Erreur:', error);
    setError(t('errors.fetchCategories'));
    setRawCategories([]);
    setCategories([]);
  } finally {
    setIsLoading(false);
  }
};

  const fetchProducts = async (
    categoryId: string,
    isPreload: boolean = false
  ): Promise<Product[]> => {
    console.log('[fetchProducts] Début pour catégorie:', {
      categoryId,
      isPreload,
    });
    if (!storeData?.store || !categoryId) {
      console.warn('[fetchProducts] storeData ou categoryId manquant:', {
        storeData,
        categoryId,
      });
      if (!isPreload && categoryId === selectedCategory) {
        notification.showNotification({
          title: t('errors.fetchProducts'),
          message: t('errors.missingData'),
          type: 'error',
        });
      }
      return [];
    }

    const cacheKey = `product_${categoryId}`;
    let products: Product[] = [];

    // Vérifier le cache IndexedDB
    try {
      const cachedData = await get(cacheKey);
      if (Array.isArray(cachedData)) {
        products = cachedData;
        console.log('[fetchProducts] Produits chargés depuis IndexedDB:', {
          categoryId,
          count: products.length,
          productIds: products.map((p) => p._id),
        });
      }
    } catch (error) {
      console.error('[fetchProducts] Erreur lecture cache IndexedDB:', error);
    }

    // Charger depuis l'API si le cache est vide
    if (!products.length) {
      try {
        const selectedCat = rawCategories.find((cat) => cat._id === categoryId);
        if (!selectedCat || !selectedCat.product_ids?.length) {
          console.log(
            '[fetchProducts] Aucune catégorie ou produit trouvé dans rawCategories pour:',
            {
              categoryId,
              rawCategoriesIds: rawCategories.map((c) => c._id),
              productIds: selectedCat?.product_ids,
            }
          );
          if (!isPreload && categoryId === selectedCategory) {
            notification.showNotification({
              title: t('errors.fetchProducts'),
              message: t('errors.noProductsFound'),
              type: 'warning',
            });
          }
          setProductsCache((prev) => ({ ...prev, [categoryId]: [] }));
          return [];
        }

        console.log(
          '[fetchProducts] product_ids à charger:',
          selectedCat.product_ids
        );
        const maxRetries = 3;
        let retryCount = 0;
        let allProducts: Product[] = [];
        while (
          retryCount < maxRetries &&
          allProducts.length < selectedCat.product_ids.length
        ) {
          try {
            const productPromises = selectedCat.product_ids.map((id) =>
              getProducts(storeData.store._id, storeData.store.server_token, id)
            );
            const responses = await Promise.all(productPromises);
            console.log(
              '[fetchProducts] Réponses API:',
              responses.map((res) => ({
                success: res.success,
                productCount: res.products?.[0]?.items?.length || 0,
                error: res.error,
                productIds: res.products?.[0]?.items?.map(
                  (p: Product) => p._id
                ),
              }))
            );
            allProducts = responses.reduce((acc, res) => {
              if (res.success && res.products?.[0]?.items) {
                const productsWithCategory = res.products[0].items.map(
                  (p: Product) => ({
                    ...p,
                    categoryId,
                  })
                );
                return [...acc, ...productsWithCategory];
              } else {
                console.warn('[fetchProducts] Réponse API non valide:', {
                  success: res.success,
                  error: res.error,
                  products: res.products,
                });
                return acc;
              }
            }, [] as Product[]);
            console.log('[fetchProducts] Produits récupérés:', {
              categoryId,
              count: allProducts.length,
              productIds: allProducts.map((p) => p._id),
            });
          } catch (error) {
            retryCount++;
            console.warn(
              `[fetchProducts] Échec, tentative ${retryCount}/${maxRetries}:`,
              error
            );
            if (retryCount === maxRetries) {
              console.error('[fetchProducts] Échec après retries:', error);
              if (!isPreload && categoryId === selectedCategory) {
                notification.showNotification({
                  title: t('errors.fetchProducts'),
                  message: t('errors.fetchProductsFailed'),
                  type: 'error',
                });
              }
              setProductsCache((prev) => ({ ...prev, [categoryId]: [] }));
              return [];
            }
            await new Promise((resolve) =>
              setTimeout(resolve, 1000 * retryCount)
            );
          }
        }
        products = sortBySequenceNumber(allProducts);
      } catch (error) {
        console.error('[fetchProducts] Erreur:', error);
        if (!isPreload && categoryId === selectedCategory) {
          notification.showNotification({
            title: t('errors.fetchProducts'),
            message: t('errors.fetchProductsFailed'),
            type: 'error',
          });
        }
        setProductsCache((prev) => ({ ...prev, [categoryId]: [] }));
        return [];
      }
    }

    products = sortBySequenceNumber(products);

    // Mettre à jour le cache par catégorie
    setProductsCache((prev) => ({
      ...prev,
      [categoryId]: products,
    }));

    // Sauvegarder dans IndexedDB
    try {
      await set(cacheKey, products);
      console.log('[fetchProducts] Produits sauvegardés dans IndexedDB:', {
        categoryId,
        count: products.length,
      });
    } catch (error) {
      console.error('[fetchProducts] Erreur sauvegarde dans IndexedDB:', error);
    }

    // Mettre à jour le cache global allProducts
    try {
      const allProducts = (await get('allProducts')) || [];
      // v5 perf : dédoublonnage par PRODUIT + CATÉGORIE (un même produit peut être dans
      // plusieurs catégories : on garde chaque couple). La version la plus récente remplace
      // l'ancienne. Avant : comparaison du JSON complet → un produit dont le prix/stock
      // changeait était AJOUTÉ en double à chaque mise à jour, et tout était re-sérialisé.
      const byKey = new Map<string, Product>();
      for (const p of [...allProducts, ...products] as Product[]) {
        if (!p || !p._id) continue;
        byKey.set(`${p._id}|${(p as any).categoryId ?? ''}`, p);
      }
      const updatedProducts = [...byKey.values()];
      await set('allProducts', updatedProducts);
      console.log(
        '[fetchProducts] Tous les produits sauvegardés dans IndexedDB:',
        {
          totalCount: updatedProducts.length,
          productIds: updatedProducts.map((p) => p._id),
        }
      );
    } catch (error) {
      console.error('[fetchProducts] Erreur sauvegarde allProducts:', error);
    }

    // Appliquer les transformations et traductions
    if (!isPreload && categoryId === activeCategoryRef.current) {
      const cacheMode = localStorage.getItem('cacheMode') || 'original';
      let translatedProducts =
        cacheMode === 'modified' ? applyClientSettings(products) : products;
      if (
        isTranslationEnabled &&
        googleApiKey &&
        i18n.language !== baseLanguage
      ) {
        translatedProducts = await translateApiData(
          translatedProducts,
          i18n.language
        );
      }
      applyProductsFor(categoryId, translatedProducts, 'fetchProducts');
    }

    // Précharger les images
    products.forEach((product: Product) => {
      if (product.image_url?.[0]) {
    cacheImage(`https://api.restomi.fr/${product.image_url[0]}`, product._id, 'product'); 
      }
    });

    return products;
  };
  const handleCategoryChange = React.useCallback(
    async (categoryId: string, force: boolean = false) => {
      if (!force && categoryId === selectedCategory) {
        console.log(
          '[handleCategoryChange] Même catégorie, ignoré:',
          categoryId
        );
        return;
      }

      // v5 anti-race : on prend un ticket pour CETTE demande. Si une autre
      // demande de catégorie démarre avant la fin de celle-ci, notre ticket
      // devient obsolète et on n'écrasera pas l'affichage courant.
      const myRequestId = ++categoryRequestIdRef.current;
      // La catégorie demandée devient immédiatement la seule "acceptée" à l'affichage
      activeCategoryRef.current = categoryId;

      setIsLoading(true);
      try {
        console.log(
          '[handleCategoryChange] Changement de catégorie:',
          categoryId
        );
        // Vérifier si les produits sont déjà en cache
        if (productsCache[categoryId]?.length) {
          console.log(
            '[handleCategoryChange] Produits trouvés dans cache:',
            categoryId
          );
          const cacheMode = localStorage.getItem('cacheMode') || 'original';
          let translatedProducts =
            cacheMode === 'modified'
              ? applyClientSettings(productsCache[categoryId])
              : productsCache[categoryId];
          if (
            isTranslationEnabled &&
            googleApiKey &&
            i18n.language !== baseLanguage
          ) {
            translatedProducts = await translateApiData(
              translatedProducts,
              i18n.language
            );
          }
          // anti-race : si une autre catégorie a été demandée entre-temps, abandon
          if (myRequestId !== categoryRequestIdRef.current) {
            console.log('[handleCategoryChange] Résultat obsolète (cache), ignoré:', categoryId);
            return;
          }
          setSelectedCategory(categoryId);
          applyProductsFor(categoryId, translatedProducts, 'handleCategoryChange/cache');
          return;
        }

        setSelectedCategory(categoryId);
        let products = await loadProducts(categoryId);
        if (!products.length) {
          // isPreload=true : fetchProducts ne doit PAS afficher lui-même (sinon
          // affichage non traduit puis traduit = clignotement). On affiche ci-dessous.
          products = await fetchProducts(categoryId, true);
        }

        const cacheMode = localStorage.getItem('cacheMode') || 'original';
        let translatedProducts =
          cacheMode === 'modified' ? applyClientSettings(products) : products;
        if (
          isTranslationEnabled &&
          googleApiKey &&
          i18n.language !== baseLanguage
        ) {
          translatedProducts = await translateApiData(
            translatedProducts,
            i18n.language
          );
        }

        // anti-race : plusieurs await ont eu lieu (loadProducts, fetchProducts,
        // traduction). Si l'utilisateur a changé de catégorie entre-temps, ce
        // résultat est obsolète → on ne l'affiche pas (évite le "saut" de produits).
        if (myRequestId !== categoryRequestIdRef.current) {
          console.log('[handleCategoryChange] Résultat obsolète (async), ignoré:', categoryId);
          return;
        }

        if (window.android?.onCategorySelected) {
          window.android.onCategorySelected(categoryId);
          console.log('[handleCategoryChange] Notifié Android:', {
            categoryId,
          });
        }

        applyProductsFor(categoryId, translatedProducts, 'handleCategoryChange');
      } catch (error) {
        console.error('[handleCategoryChange] Erreur:', error);
        // n'afficher l'erreur que si c'est toujours la demande courante
        if (myRequestId === categoryRequestIdRef.current) {
          notification.showNotification({
            title: t('errors.fetchProducts'),
            message: t('errors.fetchProductsFailed'),
            type: 'error',
          });
        }
      } finally {
        // ne couper le spinner que si notre demande est toujours la plus récente,
        // sinon une ancienne requête éteindrait le chargement d'une nouvelle.
        if (myRequestId === categoryRequestIdRef.current) {
          setIsLoading(false);
        }
      }
    },
    [
      selectedCategory,
      productsCache,
      isTranslationEnabled,
      googleApiKey,
      i18n.language,
      baseLanguage,
      t,
    ]
  );
  const handleLogin = async (credentials: LoginCredentials) => {
    console.log('[App] Tentative de login:', { credentials });
    try {
      const response = await loginStore(credentials);
      console.log('[App] Réponse loginStore:', {
        storeId: response?.store?._id,
        serverToken: response?.store?.server_token,
        fullResponse: response,
      });
      if (!response?.store?._id || !response?.store?.server_token) {
        console.error('[App] Réponse loginStore invalide:', response);
        throw new Error('Données du magasin manquantes dans la réponse');
      }
      setStoreData(response);
      setIsLoggedIn(true);
      setLoginError(undefined);
      console.log('[App] storeData défini:', response);
      notification.showNotification({
        title: t('Connexion réussie'),
        message: t('Vous êtes connecté'),
        type: 'success',
      });
    } catch (error: any) {
      console.error('[App] Erreur lors de la connexion:', {
        message: error.message,
        stack: error.stack,
        response: error.response,
      });
      setLoginError(t('Échec de la connexion'));
      notification.showNotification({
        title: t('Erreur de connexion'),
        message: t('Échec de la connexion'),
        type: 'error',
      });
    }
  };

  // v5 mode démo : connexion AUTOMATIQUE au store démo (le visiteur ne tape rien).
  const demoAutoLoginTried = useRef(false);
  useEffect(() => {
    if (!DEMO_MODE) return;
    if (isLoggedIn) return;
    if (demoAutoLoginTried.current) return;
    demoAutoLoginTried.current = true;
    console.log('[DEMO] Connexion automatique au store démo…');
    handleLogin({
      email: DEMO_STORE_EMAIL,
      password: DEMO_STORE_PASSWORD,
      login_by: 'manual',
      social_id: '',
      device_token: 'c07d4755-719f-395-d5d4-5b1cc44a1562',
      device_type: 'web',
      app_version: 'v.1.2',
      store_type: 0,
    } as LoginCredentials);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  const handleLogout = async () => {
    // v5 mode démo : NE JAMAIS déconnecter du store démo. La démo reste toujours
    // connectée (sinon le visiteur retomberait sur l'écran de login). Le bouton
    // "Mode client" se contente de sortir de l'admin.
    if (DEMO_MODE) {
      console.log('[DEMO] Déconnexion bloquée — on reste connecté au store démo.');
      setIsAdmin(false);
      return;
    }
    try {
      if (storeData?.store) {
        await logoutStore(storeData.store._id, storeData.store.server_token);
      }
      setStoreData(null);
      setIsLoggedIn(false);
      setCategories([]);
      setProducts([]);
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('storeData');
      notification.showNotification({
        title: t('Déconnexion réussie'),
        message: t('Vous avez été déconnecté'),
        type: 'info',
      });
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
      notification.showNotification({
        title: t('Erreur de déconnexion'),
        message: t('Problème déconnexion'),
        type: 'error',
      });
    }
  };

// Fonction utilitaire pour détecter les options exclusives (se terminant par ❌)
const isExclusiveOption = (optionName: string): boolean => {
  return optionName?.trim().endsWith('❌') || false;
};

const handleSpecificationChange = (specId: string, optionId: string, forceAdd: boolean = false) => {
  setSelectedSpecifications((prev) => {
    const current = prev[specId] || [];
    const spec = selectedProduct?.specifications.find((s) => s._id === specId);
    if (!spec) {
      console.warn('[handleSpecificationChange] Spécification non trouvée', { specId });
      return prev;
    }

    console.log('[handleSpecificationChange] Changement de sélection', {
      specId,
      optionId,
      type: spec.type,
      range: spec.range,
      max_range: spec.max_range,
      is_required: spec.is_required,
      user_can_add_specification_quantity: spec.user_can_add_specification_quantity,
      currentSelections: current,
      forceAdd,
    });

    if (spec.type === 2) {
      const maxRange = spec.max_range > 0 ? spec.max_range : spec.range > 0 ? spec.range : 10;

      // Récupérer l'option cliquée
      const clickedOption = spec.list.find((opt) => opt._id === optionId);
      const isClickedExclusive = clickedOption ? isExclusiveOption(clickedOption.name?.[0] || '') : false;

      // Vérifier si des options exclusives existent dans les sélections actuelles
      const currentExclusiveIds = current.filter((id) => {
        const opt = spec.list.find((o) => o._id === id);
        return opt ? isExclusiveOption(opt.name?.[0] || '') : false;
      });

      console.log('[handleSpecificationChange] Analyse exclusion mutuelle', {
        isClickedExclusive,
        currentExclusiveIds,
        clickedOptionName: clickedOption?.name?.[0],
      });

      // Si l'option cliquée est exclusive (❌)
      if (isClickedExclusive) {
        if (spec.user_can_add_specification_quantity) {
          // Si l'option exclusive est déjà sélectionnée, la retirer
          if (current.includes(optionId)) {
            console.log('[handleSpecificationChange] Option exclusive déjà sélectionnée - retrait');
            return { ...prev, [specId]: [] };
          }
          // Sinon, vider toutes les sélections et ajouter uniquement l'option ❌
          console.log('[handleSpecificationChange] Option exclusive cliquée - vider et ajouter');
          return { ...prev, [specId]: [optionId] };
        } else {
          // Cas sans quantités : si déjà sélectionné, désélectionner, sinon remplacer
          if (current.includes(optionId)) {
            console.log('[handleSpecificationChange] Option exclusive déjà sélectionnée - retrait');
            return { ...prev, [specId]: [] };
          }
          // Vider tout et ajouter uniquement l'option ❌
          console.log('[handleSpecificationChange] Option exclusive cliquée - remplacer toutes');
          return { ...prev, [specId]: [optionId] };
        }
      }

      // Si l'option cliquée est normale et qu'une option ❌ existe déjà
      if (!isClickedExclusive && currentExclusiveIds.length > 0) {
        // Retirer toutes les options exclusives avant d'ajouter l'option normale
        const filteredCurrent = current.filter((id) => !currentExclusiveIds.includes(id));
        console.log('[handleSpecificationChange] Retrait des options exclusives existantes', {
          filteredCurrent,
          removed: currentExclusiveIds,
        });

        if (spec.user_can_add_specification_quantity) {
          // Si forceAdd est true (bouton +), toujours ajouter
          if (forceAdd) {
            if (filteredCurrent.length >= maxRange) {
              console.warn('[handleSpecificationChange] Limite de sélection atteinte', {
                specId,
                maxRange,
                currentCount: filteredCurrent.length,
              });
              notification.showNotification({
                title: t('Limite atteinte'),
                message: t("Vous ne pouvez sélectionner que jusqu'à {count} options pour {name}", {
                  count: maxRange,
                  name: spec.name[0] || t('cette option'),
                }),
                type: 'warning',
              });
              return prev;
            }
            console.log('[handleSpecificationChange] Ajout forcé après retrait des exclusives');
            return { ...prev, [specId]: [...filteredCurrent, optionId] };
          }
          // Si l'option est déjà sélectionnée, la retirer complètement
          if (filteredCurrent.includes(optionId)) {
            console.log('[handleSpecificationChange] Option déjà sélectionnée - retrait complet');
            return { ...prev, [specId]: filteredCurrent.filter((id) => id !== optionId) };
          }
          // Sinon, ajouter l'option une seule fois
          if (filteredCurrent.length >= maxRange) {
            console.warn('[handleSpecificationChange] Limite de sélection atteinte', {
              specId,
              maxRange,
              currentCount: filteredCurrent.length,
            });
            notification.showNotification({
              title: t('Limite atteinte'),
              message: t("Vous ne pouvez sélectionner que jusqu'à {count} options pour {name}", {
                count: maxRange,
                name: spec.name[0] || t('cette option'),
              }),
              type: 'warning',
            });
            return prev;
          }
          console.log('[handleSpecificationChange] Nouvelle sélection avec quantité 1');
          return { ...prev, [specId]: [...filteredCurrent, optionId] };
        } else {
          if (filteredCurrent.includes(optionId)) {
            return { ...prev, [specId]: filteredCurrent.filter((id) => id !== optionId) };
          }
          if (filteredCurrent.length >= maxRange) {
            console.warn('[handleSpecificationChange] Limite de sélection atteinte', {
              specId,
              maxRange,
              currentCount: filteredCurrent.length,
            });
            notification.showNotification({
              title: t('Limite atteinte'),
              message: t("Vous ne pouvez sélectionner que jusqu'à {count} options pour {name}", {
                count: maxRange,
                name: spec.name[0] || t('cette option'),
              }),
              type: 'warning',
            });
            return prev;
          }
          return { ...prev, [specId]: [...filteredCurrent, optionId] };
        }
      }

      // Logique normale (aucune option exclusive impliquée)
      if (spec.user_can_add_specification_quantity) {
        // Si forceAdd est true (bouton +), toujours ajouter
        if (forceAdd) {
          if (current.length >= maxRange) {
            console.warn('[handleSpecificationChange] Limite de sélection atteinte', {
              specId,
              maxRange,
              currentCount: current.length,
            });
            notification.showNotification({
              title: t('Limite atteinte'),
              message: t("Vous ne pouvez sélectionner que jusqu'à {count} options pour {name}", {
                count: maxRange,
                name: spec.name[0] || t('cette option'),
              }),
              type: 'warning',
            });
            return prev;
          }
          console.log('[handleSpecificationChange] Ajout forcé de quantité supplémentaire');
          return { ...prev, [specId]: [...current, optionId] };
        }
        // Si l'option est déjà sélectionnée, la retirer complètement
        if (current.includes(optionId)) {
          console.log('[handleSpecificationChange] Option déjà sélectionnée - retrait complet');
          return { ...prev, [specId]: current.filter((id) => id !== optionId) };
        }
        // Sinon, ajouter l'option une seule fois
        if (current.length >= maxRange) {
          console.warn('[handleSpecificationChange] Limite de sélection atteinte', {
            specId,
            maxRange,
            currentCount: current.length,
          });
          notification.showNotification({
            title: t('Limite atteinte'),
            message: t("Vous ne pouvez sélectionner que jusqu'à {count} options pour {name}", {
              count: maxRange,
              name: spec.name[0] || t('cette option'),
            }),
            type: 'warning',
          });
          return prev;
        }
        console.log('[handleSpecificationChange] Nouvelle sélection avec quantité 1');
        return { ...prev, [specId]: [...current, optionId] };
      } else {
        if (current.includes(optionId)) {
          return { ...prev, [specId]: current.filter((id) => id !== optionId) };
        }
        if (current.length >= maxRange) {
          console.warn('[handleSpecificationChange] Limite de sélection atteinte', {
            specId,
            maxRange,
            currentCount: current.length,
          });
          notification.showNotification({
            title: t('Limite atteinte'),
            message: t("Vous ne pouvez sélectionner que jusqu'à {count} options pour {name}", {
              count: maxRange,
              name: spec.name[0] || t('cette option'),
            }),
            type: 'warning',
          });
          return prev;
        }
        return { ...prev, [specId]: [...current, optionId] };
      }
    } else {
      return { ...prev, [specId]: [optionId] };
    }
  });
};

const handleSpecificationDecrease = (specId: string, optionId: string) => {
  setSelectedSpecifications((prev) => {
    const current = prev[specId] || [];
    const index = current.lastIndexOf(optionId);
    if (index === -1) return prev;
    const newSelections = [...current];
    newSelections.splice(index, 1);
    return { ...prev, [specId]: newSelections };
  });
};

const handleNextSpecification = () => {
  if (!selectedProduct) {
    console.error('[handleNextSpecification] Aucun produit sélectionné');
    setSpecError('unknown');
    notification.showNotification({
      title: t('Erreur'),
      message: t('Produit non trouvé. Veuillez réessayer.'),
      type: 'error',
    });
    return;
  }

  const visibleSpecs = selectedProduct.specifications.filter(
    (spec) => specificationSettings[selectedProduct._id]?.[spec._id]?.visible ?? true
  );

  if (visibleSpecs.length === 0) {
    console.warn('[handleNextSpecification] Aucune spécification visible');
    addToCart(selectedProduct, selectedSpecifications);
    setShowSpecifications(false);
    setCurrentSpecificationIndex(0);
    notification.showNotification({
      title: t('Produit ajouté'),
      message: t('Produit ajouté au panier', { name: selectedProduct.name[0] }),
      type: 'success',
    });
    return;
  }

  const currentSpec = visibleSpecs[currentSpecificationIndex];
  if (!currentSpec) {
    console.error('[handleNextSpecification] Spécification introuvable', {
      index: currentSpecificationIndex,
      totalSpecs: visibleSpecs.length,
    });
    setSpecError('unknown');
    notification.showNotification({
      title: t('Erreur'),
      message: t('Spécification non trouvée. Veuillez réessayer.'),
      type: 'error',
    });
    return;
  }

  console.log('[handleNextSpecification] Traitement de la spécification:', {
    specId: currentSpec._id,
    name: currentSpec.name[0],
    type: currentSpec.type,
    range: currentSpec.range,
    is_required: currentSpec.is_required,
    options: currentSpec.list.map((opt) => ({
      id: opt._id,
      name: opt.name[0],
      visible: subproductSettings[selectedProduct._id]?.[opt.name?.[0]]?.visible ?? true,
    })),
  });

  const selections = selectedSpecifications[currentSpec._id] || [];
  console.log('[handleNextSpecification] Sélections:', {
    specId: currentSpec._id,
    selections,
    count: selections.length,
  });

  // Vérifier si une option exclusive (❌) est sélectionnée
  const hasExclusiveOption = selections.some((selectedId) => {
    const selectedOption = currentSpec.list.find((opt) => opt._id === selectedId);
    return selectedOption ? isExclusiveOption(selectedOption.name?.[0] || '') : false;
  });

  console.log('[handleNextSpecification] Vérification option exclusive:', {
    hasExclusiveOption,
    selections,
  });

  // Validation pour spécifications obligatoires
  if (currentSpec.is_required && currentSpec.list.length > 0) {
    if (selections.length === 0) {
      setSpecError(currentSpec._id);
      setIsVibrating(true);
      setTimeout(() => setIsVibrating(false), 900);
      const name = currentSpec.name[0] || t('cette option');
      console.warn('[handleNextSpecification] Aucune sélection pour une spécification requise', {
        specId: currentSpec._id,
        name,
      });
      notification.showNotification({
        title: t('Sélection requise'),
        message: t('Veuillez sélectionner une option pour {name}', { name }),
        type: 'warning',
      });
      return;
    }

    // Si une option exclusive (❌) est sélectionnée, bypass la validation du minimum
    if (currentSpec.type === 2 && currentSpec.range > 0 && !hasExclusiveOption) {
      if (selections.length < currentSpec.range) {
        setSpecError(currentSpec._id);
        setIsVibrating(true);
        setTimeout(() => setIsVibrating(false), 900);
        const name = currentSpec.name[0] || t('cette option');
        console.warn('[handleNextSpecification] Sélections insuffisantes', {
          specId: currentSpec._id,
          required: currentSpec.range,
          selected: selections.length,
          name,
        });
        notification.showNotification({
          title: t('Sélection incomplète'),
          message: t('Veuillez sélectionner options', {
            count: currentSpec.range,
            name,
          }),
          type: 'warning',
        });
        return;
      }
    }

    // Si une option exclusive est sélectionnée, toujours autoriser de passer
    if (hasExclusiveOption) {
      console.log('[handleNextSpecification] Option exclusive sélectionnée - validation bypassée', {
        specId: currentSpec._id,
        selections,
      });
    }
  } else {
    // Pour spécifications non obligatoires
    if (currentSpec.type === 2 && currentSpec.range > 0 && selections.length > currentSpec.range) {
      setSpecError(currentSpec._id);
      setIsVibrating(true);
      setTimeout(() => setIsVibrating(false), 900);
      const name = currentSpec.name[0] || t('cette option');
      console.warn('[handleNextSpecification] Trop de sélections', {
        specId: currentSpec._id,
        maxAllowed: currentSpec.range,
        selected: selections.length,
        name,
      });
      notification.showNotification({
        title: t('Trop de sélections'),
        message: t('Vous ne pouvez sélectionner que {count} options pour {name}', {
          count: currentSpec.range,
          name,
        }),
        type: 'warning',
      });
      return;
    }
    // Autoriser 0 sélection pour non obligatoire
    console.log('[handleNextSpecification] Spécification non obligatoire, sélections validées', {
      specId: currentSpec._id,
      selections: selections.length,
    });
  }

  setSpecError(null);
  setIsVibrating(false);

  if (currentSpecificationIndex < visibleSpecs.length - 1) {
    setCurrentSpecificationIndex(currentSpecificationIndex + 1);
  } else {
    console.log('[handleNextSpecification] Toutes les spécifications complétées', {
      selectedSpecifications,
    });
    addToCart(selectedProduct, selectedSpecifications);
    setShowSpecifications(false);
    setCurrentSpecificationIndex(0);
    setSelectedSpecifications({}); // Réinitialiser les sélections
    notification.showNotification({
      title: t('Produit ajouté'),
      message: t('Produit ajouté au panier', { name: selectedProduct.name[0] }),
      type: 'success',
    });
  }
};
  const handlePreviousSpecification = () => {
    if (currentSpecificationIndex > 0)
      setCurrentSpecificationIndex(currentSpecificationIndex - 1);
  };

  const handleAddToCart = React.useCallback(
    (product: Product) => {
      // Vérifier si un ajout est en cours pour ce produit
      const clickTimeoutKey = `clickTimeout_${product._id}`;
      if (window[clickTimeoutKey]) {
        console.log('[handleAddToCart] Clic ignoré (débouncing):', product._id);
        return;
      }

      // Définir un timeout pour bloquer les clics répétés
      window[clickTimeoutKey] = setTimeout(() => {
        delete window[clickTimeoutKey];
      }, 500); // 500ms de délai

      try {
        console.log('[handleAddToCart] Début pour produit:', product._id);

        // Récupérer les données du cache de manière synchrone
        const cachedProducts = productsCache[selectedCategory] || [];
        const cacheMode = localStorage.getItem('cacheMode') || 'original';
        let modifiedProduct = product;

        if (cacheMode === 'modified' && cachedProducts.length > 0) {
          const modifiedProducts = applyClientSettings(cachedProducts);
          modifiedProduct = modifiedProducts.find((p) => p._id === product._id) || product;
        }

        // Vérifier si le produit a des spécifications - si oui, ouvrir le popup INSTANTANÉMENT
        if (modifiedProduct.specifications && modifiedProduct.specifications.length > 0) {
          console.log('[handleAddToCart] Ouverture instantanée du popup avec données complètes pour:', modifiedProduct._id);

          // Précharger toutes les images des specifications
          modifiedProduct.specifications.forEach(spec => {
            spec.list.forEach(option => {
              if (option.image_url) {
                preloadImage(option.image_url);
              }
            });
          });

          // Ouvrir le popup INSTANTANÉMENT avec toutes les données
          setSelectedProduct(modifiedProduct);
          setShowSpecifications(true);
          setSelectedSpecifications({});
          setCurrentSpecificationIndex(0);
          return;
        }

        // Si pas de spécifications, ajouter directement au panier
        console.log('[handleAddToCart] Ajout direct au panier:', modifiedProduct._id);
        addToCart(modifiedProduct, {});
        notification.showNotification({
          title: t('Produit ajouté'),
          message: t('Produit ajouté au panier', {
            name: modifiedProduct.name[0],
          }),
          type: 'success',
        });
      } catch (error) {
        console.error('[handleAddToCart] Erreur:', error);
        notification.showNotification({
          title: t('Erreur'),
          message: t("Impossible d'ajouter le produit au panier"),
          type: 'error',
        });
      } finally {
        // Nettoyer le timeout en cas d'erreur
        if (window[clickTimeoutKey]) {
          clearTimeout(window[clickTimeoutKey]);
          delete window[clickTimeoutKey];
        }
      }
    },
    [selectedCategory, t]
  );
  useEffect(() => {
    if (selectedCategory && productsCache[selectedCategory]?.length) {
      console.log(
        '[useEffect] Synchronisation des produits pour catégorie:',
        selectedCategory
      );
      const cacheMode = localStorage.getItem('cacheMode') || 'original';
      let translatedProducts =
        cacheMode === 'modified'
          ? applyClientSettings(productsCache[selectedCategory])
          : productsCache[selectedCategory];

      const categoryId = selectedCategory;
      let cancelled = false;
      // Appliquer la traduction si nécessaire
      const applyTranslation = async () => {
        if (
          isTranslationEnabled &&
          googleApiKey &&
          i18n.language !== baseLanguage
        ) {
          translatedProducts = await translateApiData(
            translatedProducts,
            i18n.language
          );
        }
        // Un rendu plus récent a relancé cet effet → ce résultat est périmé
        if (cancelled) return;
        applyProductsFor(categoryId, translatedProducts, 'syncEffect');
      };

      applyTranslation();
      return () => {
        cancelled = true;
      };
    }
  }, [
    selectedCategory,
    productsCache,
    isTranslationEnabled,
    googleApiKey,
    i18n.language,
    baseLanguage,
  ]);

  const addToCart = (
    product: Product,
    specifications: { [key: string]: string[] }
  ) => {
    setCartItems((prev) => {
      const additionalPrice = Object.entries(specifications).reduce(
        (total, [specId, optionIds]) => {
          const spec = product.specifications.find((s) => s._id === specId);
          if (!spec) return total;
          return (
            total +
            optionIds.reduce((sum, optId) => {
              const option = spec.list.find((opt) => opt._id === optId);
              return sum + (option?.price || 0);
            }, 0)
          );
        },
        0
      );

const menuItem: MenuItem = {
  id: product._id,
  name: product.name[0],
  description: product.details[0],
  price: productSettings[product._id]?.price ?? product.price,
  image: product.image_url[0]
    ? cacheImage(`https://api.restomi.fr/${product.image_url[0]}`)
    : '',
  category: selectedCategory,
  available: product.is_item_in_stock,
  customizations: [],
  tax: product.tax || 0,
  tax_details: product.tax_details || [],
};

      const selectedCustomizations: {
        [key: string]: { id: string; name: string; price: number }[];
      } = {};
      Object.entries(specifications).forEach(([specId, optionIds]) => {
        const spec = product.specifications.find((s) => s._id === specId);
        if (spec) {
          const selectedOptions: { id: string; name: string; price: number }[] = [];
          optionIds.forEach((optId) => {
            const opt = spec.list.find((o) => o._id === optId);
            if (opt) {
              selectedOptions.push({
                id: opt._id,
                name: opt.name[0],
                price: opt.price,
              });
            }
          });
          if (selectedOptions.length > 0) {
            selectedCustomizations[spec.name[0]] = selectedOptions;
          }
        }
      });

      if (!isMobile) setShowCart(true);
      console.log('Ajout au panier - menuItem:', menuItem);
      console.log(
        'Ajout au panier - Customisations sélectionnées:',
        selectedCustomizations
      );

      if (editingCartItemId) {
        const existingItem = prev.find((item) => item.uniqueId === editingCartItemId);
        return prev.map((item) =>
          item.uniqueId === editingCartItemId
            ? {
                ...item,
                menuItem,
                customizations: selectedCustomizations,
                quantity: existingItem?.quantity || 1,
              }
            : item
        );
      }

      const uniqueId = `${product._id}-${Date.now()}`;
      return [
        ...prev,
        {
          menuItem,
          quantity: 1,
          customizations: selectedCustomizations,
          uniqueId,
        },
      ];
    });

    if (editingCartItemId) {
      notification.showNotification({
        title: t('Produit modifie'),
        message: t('Les modifications ont ete enregistrees'),
        type: 'success',
      });
      setEditingCartItemId(null);
    }

    setShowSpecifications(false);
    setSelectedProduct(null);
    setCurrentSpecificationIndex(0);
  };

  const handleUpdateQuantity = (uniqueId: string, quantity: number) => {
    if (quantity < 1) {
      handleRemoveItem(uniqueId);
      return;
    }
    setCartItems((prev) =>
      prev.map((item) =>
        item.uniqueId === uniqueId ? { ...item, quantity } : item
      )
    );
  };

  const handleRemoveItem = (uniqueId: string) => {
    setCartItems((prev) => {
      const itemToRemove = prev.find((item) => item.uniqueId === uniqueId);
      if (itemToRemove) {
        notification.showNotification({
          title: t('Produit retiré'),
          message: t('Produit retiré du panier', {
            name: itemToRemove.menuItem.name,
          }),
          type: 'info',
        });
      }
      return prev.filter((item) => item.uniqueId !== uniqueId);
    });
  };

  const handleEditCartItem = async (cartItem: CartItem) => {
    try {
      const productId = cartItem.menuItem.id;
      let product: Product | undefined;

      for (const [_, categoryProducts] of Object.entries(productsCache)) {
        product = categoryProducts.find((p: Product) => p._id === productId);
        if (product) break;
      }

      if (!product && allProducts.length > 0) {
        product = allProducts.find((p) => p._id === productId);
      }

      if (!product) {
        notification.showNotification({
          title: t('Erreur'),
          message: t('Produit non trouve'),
          type: 'error',
        });
        return;
      }

      const cacheMode = localStorage.getItem('cacheMode') || 'original';
      let modifiedProduct = product;
      if (cacheMode === 'modified') {
        const modifiedProducts = applyClientSettings([product]);
        modifiedProduct = modifiedProducts[0] || product;
      }

      const restoredSpecifications: { [key: string]: string[] } = {};
      if (modifiedProduct.specifications) {
        Object.entries(cartItem.customizations).forEach(([specName, options]) => {
          const spec = modifiedProduct!.specifications.find((s) => s.name[0] === specName);
          if (spec) {
            restoredSpecifications[spec._id] = options.map((opt) => opt.id);
          }
        });
      }

      setSelectedProduct(modifiedProduct);
      setSelectedSpecifications(restoredSpecifications);
      setEditingCartItemId(cartItem.uniqueId);
      setCurrentSpecificationIndex(0);
      setShowSpecifications(true);
    } catch (error) {
      console.error('[handleEditCartItem] Erreur:', error);
      notification.showNotification({
        title: t('Erreur'),
        message: t('Impossible de modifier ce produit'),
        type: 'error',
      });
    }
  };

  const [allProducts, setAllProducts] = useState<Product[]>([]);

  useEffect(() => {
    const loadAllProducts = async () => {
      try {
        const cachedProducts = await get('allProducts');
        if (Array.isArray(cachedProducts)) {
          setAllProducts(cachedProducts);
          console.log('[loadAllProducts] Produits chargés depuis IndexedDB:', {
            count: cachedProducts.length,
          });
        }
      } catch (error) {
        console.error('[loadAllProducts] Erreur:', error);
      }
    };
    loadAllProducts();
  }, []);

  useEffect(() => {
    const loadCartTimeoutSettings = async () => {
      try {
        const savedSettings = await settingsStorage.getCartTimeoutSettings();
        setCartTimeoutSettings(savedSettings);
        console.log('[App] Cart timeout settings loaded:', savedSettings);
      } catch (error) {
        console.error('[App] Error loading cart timeout settings:', error);
      }
    };
    loadCartTimeoutSettings();

    const handleStorageChange = () => {
      loadCartTimeoutSettings();
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const resetActivity = useCallback(() => {
    lastActivityRef.current = Date.now();
    if (isWarningActive) {
      setIsWarningActive(false);
      setWarningCountdown(0);
    }
  }, [isWarningActive]);

  useEffect(() => {
    const handleActivity = () => {
      resetActivity();
    };

    window.addEventListener('touchstart', handleActivity);
    window.addEventListener('mousedown', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('scroll', handleActivity);

    return () => {
      window.removeEventListener('touchstart', handleActivity);
      window.removeEventListener('mousedown', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('scroll', handleActivity);
    };
  }, [resetActivity]);

  useEffect(() => {
    const checkInactivity = setInterval(() => {
      const now = Date.now();
      const timeSinceLastActivity = (now - lastActivityRef.current) / 1000;
      const hasItems = cartItems.length > 0;

      if (!hasItems) {
        if (isWarningActive) {
          setIsWarningActive(false);
          setWarningCountdown(0);
        }
        return;
      }

      if (isWarningActive) {
        const newCountdown = warningCountdown - 1;
        if (newCountdown <= 0) {
          setCartItems([]);
          setShowCart(false);
          setIsWarningActive(false);
          setWarningCountdown(0);
          i18n.changeLanguage(baseLanguage || 'fr');
          notification.showNotification({
            title: t('Panier vidé'),
            message: t('Votre panier a été vidé après inactivité'),
            type: 'info',
          });
          lastActivityRef.current = Date.now();
        } else {
          setWarningCountdown(newCountdown);
        }
      } else if (timeSinceLastActivity >= cartTimeoutSettings.inactivityTimeout) {
        setIsWarningActive(true);
        setWarningCountdown(cartTimeoutSettings.cartWarningDuration);
      }
    }, 1000);

    return () => clearInterval(checkInactivity);
  }, [cartItems, isWarningActive, warningCountdown, cartTimeoutSettings, baseLanguage, i18n, t, notification]);

  const handleCheckout = async () => {
    notification.showNotification({
      title: t('Commande confirmée'),
      message: t('Votre commande confirmée'),
      type: 'success',
    });
    setCartItems([]); // Vide le panier
    setShowCart(false); // Ferme le panier

    // v5: nouveau client → resynchroniser happy hour et rush.
    // Le happy hour a pu démarrer/s'arrêter pendant la commande précédente.
    happyHourState.refresh();
    rush.refresh();

    // Réinitialiser à la première catégorie
    if (categories.length > 0) {
      const firstCategoryId = categories[0]._id;
      console.log(
        '[handleCheckout] Resélection de la première catégorie:',
        firstCategoryId
      );
      activeCategoryRef.current = firstCategoryId;
      setSelectedCategory(firstCategoryId);
      // Forcer le chargement des produits de la première catégorie
      await handleCategoryChange(firstCategoryId, true); // Attendre la fin
      console.log(
        '[handleCheckout] handleCategoryChange terminé pour:',
        firstCategoryId
      );
    } else {
      console.warn('[handleCheckout] Aucune catégorie disponible');
      notification.showNotification({
        title: t('Erreur'),
        message: t('Aucune catégorie disponible pour sélection'),
        type: 'warning',
      });
      await fetchCategories(); // Tenter de recharger les catégories
    }

    // Changer la langue après avoir défini la catégorie
    await changeLanguage(baseLanguage); // Réapplique la langue de base
    console.log('[handleCheckout] Changement de langue terminé');
  };
  const handleUpdateMenuItem = (updatedItem: MenuItem) => {
    setMenuItems((prev) =>
      prev.map((item) => (item.id === updatedItem.id ? updatedItem : item))
    );
  };

  const handleUpdateOrderStatus = (
    orderId: string,
    status: Order['status']
  ) => {
    console.log('Mise à jour du statut de la commande:', orderId, status);
  };

  const toggleAdmin = () => {
    setIsAdmin(!isAdmin);
    if (!isAdmin && !isLoggedIn) setStoreData(null);
  };

  const handlePrintSettingsChange = async (
    newSettings: 'manual' | 'auto' | 'none'
  ) => {
    try {
      console.log('[App] Sauvegarde IMMEDIATE des paramètres d\'impression:', newSettings);

      await settingsStorage.savePrintSettings(newSettings);
      console.log('[App] Paramètres d\'impression sauvegardés avec succès dans IndexedDB:', newSettings);

      setPrintSettings(newSettings);

      notification.showNotification({
        title: t('Paramètres impression mis à jour'),
        message: t('Mode impression défini', {
          mode:
            newSettings === 'manual'
              ? t('manuel')
              : newSettings === 'auto'
              ? t('automatique')
              : t('aucun'),
        }),
        type: 'success',
        duration: 3000,
      });
    } catch (error) {
      console.error('[App] ERREUR lors de la sauvegarde des paramètres d\'impression:', error);
      notification.showNotification({
        title: t('Erreur de stockage'),
        message: t('Impossible sauvegarder paramètres impression'),
        type: 'error',
        duration: 5000,
      });
    }
  };

  const handleDisplayModeChange = (
    newMode: 'auto' | 'mobile' | 'desktop-2' | 'desktop-3'
  ) => {
    try {
      console.log('[App] Sauvegarde IMMEDIATE du mode d\'affichage:', newMode);

      // Vérifier l'espace disponible
      const testKey = '__storage_test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);

      localStorage.setItem('displayMode', newMode);
      console.log('[App] Mode d\'affichage sauvegardé avec succès dans localStorage:', newMode);

      setDisplayMode(newMode);

      notification.showNotification({
        title: t('Paramètres enregistrés'),
        message: t('Le mode d\'affichage a été mis à jour.'),
        type: 'success',
        duration: 3000,
      });
    } catch (error: any) {
      console.error('[App] ERREUR lors de la sauvegarde du mode d\'affichage:', error);

      if (error.name === 'QuotaExceededError') {
        console.warn('localStorage plein, tentative de nettoyage...');
        // Supprimer les données non critiques
        localStorage.removeItem('translationCache');
        localStorage.removeItem('productsCache');

        // Réessayer
        try {
          localStorage.setItem('displayMode', newMode);
          setDisplayMode(newMode);
          console.log('[App] Réessai réussi pour displayMode');

          notification.showNotification({
            title: t('Paramètres enregistrés'),
            message: t('Le mode d\'affichage a été mis à jour après nettoyage.'),
            type: 'success',
            duration: 3000,
          });
        } catch (retryError) {
          console.error('Échec du réessai:', retryError);
          notification.showNotification({
            title: t('Erreur de stockage'),
            message: t('Espace stockage insuffisant'),
            type: 'error',
            duration: 5000,
          });
        }
      } else {
        notification.showNotification({
          title: t('Erreur de stockage'),
          message: t('Impossible sauvegarder paramètres affichage'),
          type: 'error',
          duration: 5000,
        });
      }
    }
  };

  useEffect(() => {
    if (categories.length > 0 && !selectedCategory) {
      activeCategoryRef.current = categories[0]._id;
      setSelectedCategory(categories[0]._id);
      handleCategoryChange(categories[0]._id, true);
    }
  }, [categories, selectedCategory]);

  // Capturer les erreurs globales
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      console.warn('Erreur capturée:', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
      });
    };
    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);
  const changeLanguage = async (lang: string) => {
    console.log('[changeLanguage] Changement de langue demandé:', {
      lang,
      baseLanguage,
      currentLang: i18n.language,
      rawCurrency,
    });
    try {
      // Mettre à jour la référence du dernier changement de langue
      lastLanguageChangeRef.current = Date.now();

      // Changer la langue dans i18n
      await i18n.changeLanguage(lang);
      console.log('[changeLanguage] Langue changée:', {
        newLang: i18n.language,
      });

      // Mettre à jour l'état language
      setLanguage(lang);

      // Traduire la devise
      let translatedCurrency = rawCurrency;
      if (lang !== baseLanguage && isTranslationEnabled && googleApiKey) {
        try {
          translatedCurrency = await translateText(rawCurrency, lang);
          console.log('[changeLanguage] Devise traduite:', {
            from: rawCurrency,
            to: translatedCurrency,
            lang,
          });
        } catch (error) {
          console.error('[changeLanguage] Erreur traduction devise:', {
            errorMessage: error.message,
            errorStack: error.stack,
          });
          translatedCurrency = rawCurrency;
        }
      }
      setCurrency(translatedCurrency);

      // Retraduire les catégories
      if (rawCategories.length > 0) {
        console.log('[changeLanguage] Début traduction des catégories:', {
          categoriesCount: rawCategories.length,
        });
        try {
          const translatedCategories = await translateApiData(
            rawCategories,
            lang
          );
          setCategories(translatedCategories);
        } catch (error) {
          console.error('[changeLanguage] Erreur traduction catégories:', {
            errorMessage: error.message,
            errorStack: error.stack,
          });
          setCategories(rawCategories);
          notification.showNotification({
            title: t('errors.translation'),
            message: t('errors.translationFailed'),
            type: 'error',
          });
        }
      } else {
        setCategories(rawCategories);
      }

      // Retraduire les produits
      // Retraduire les produits pour la catégorie actuelle
      const langCategory = activeCategoryRef.current || selectedCategory;
      if (langCategory && productsCache[langCategory]) {
        console.log(
          '[changeLanguage] Début traduction des produits pour catégorie:',
          {
            categoryId: langCategory,
            productsCount: productsCache[langCategory].length,
          }
        );
        try {
          const translatedProducts = await translateApiData(
            productsCache[langCategory],
            lang
          );
          applyProductsFor(langCategory, translatedProducts, 'changeLanguage');
        } catch (error) {
          console.error('[changeLanguage] Erreur traduction produits:', {
            errorMessage: error.message,
            errorStack: error.stack,
          });
          applyProductsFor(langCategory, productsCache[langCategory], 'changeLanguage/erreur');
          notification.showNotification({
            title: t('errors.translation'),
            message: t('errors.translationFailed'),
            type: 'error',
          });
        }
      } else {
        setProducts([]);
      }

      // Forcer le rendu
      setForceRender((prev) => prev + 1);
    } catch (error) {
      console.error('[changeLanguage] Erreur changement de langue:', {
        errorMessage: error.message,
        errorStack: error.stack,
      });
      notification.showNotification({
        title: t('errors.languageChange'),
        message: t('errors.languageChangeFailed'),
        type: 'error',
      });
    }
  };
 
  return (
    <WrappedAppErrorBoundary>
      {showIntro ? (
        <Intro onFinish={() => setShowIntro(false)} />
      ) : storeModules.isKioskDisabled ? (
        // v5 Modules : blocage ADMIN (abonnement/suspension).
        // PRIORITAIRE sur le Rush, et bloque même si le panier n'est pas vide :
        // le backend refusera la commande de toute façon, autant prévenir tout de suite.
        <ModuleDisabledScreen
          backendMessage={storeModules.disabledMessage}
          storeName={getStoreInfo()?.name}
          logoUrl={getStoreInfo()?.image_url}
        />
      ) : shouldBlockForRush ? (
        // v5 Mode Rush : blocage des NOUVELLES commandes uniquement.
        // Les paniers déjà entamés ne passent jamais ici (voir shouldBlockForRush).
        <RushBlockScreen
          message={rush.message}
          remainingSeconds={rush.remainingSeconds}
          isScheduled={rush.isScheduled}
          reopenDate={rush.reopenDate}
          storeName={getStoreInfo()?.name}
          logoUrl={getStoreInfo()?.image_url}
        />
      ) : (
        <div className="relative">
{isAdmin ? (
  isLoggedIn ? (
    <>
      <button
        onClick={toggleAdmin}
        className="fixed top-4 right-4 bg-gray-800 text-white px-4 py-2 rounded-lg z-50"
      >
        {t('Mode client')}
      </button>
    
      <Suspense
        fallback={
          <div className="fixed inset-0 flex items-center justify-center bg-gray-50 z-40">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
              <p className="text-gray-600 text-sm">{t('Chargement du panel admin')}…</p>
            </div>
          </div>
        }
      >
        <AdminDashboard
          stats={mockStats}
          orders={mockOrders}
          menuItems={menuItems}
          categories={categories || []}
          products={products || []}
          allProducts={allProducts || []}
          onUpdateMenuItem={handleUpdateMenuItem}
          onUpdateOrderStatus={handleUpdateOrderStatus}
          onLogout={handleLogout}
          cleanupSettings={cleanupSettings}
          onSaveCleanupSettings={saveCleanupSettings}
          themeSettings={themeSettings}
          onSaveTheme={saveTheme}
          onPrintSettingsChange={handlePrintSettingsChange}
          displayMode={displayMode}
          onChangeDisplayMode={handleDisplayModeChange}
          storeData={storeData || {}}
          notification={notification}

        />
      </Suspense>
      <ModernNotification
        title={notification.title}
        message={notification.message}
        type={notification.type}
        isOpen={notification.isOpen}
        onClose={notification.hideNotification}
        duration={notification.duration}
        actions={notification.actions}
      />
    </>
  ) : (
    <LoginForm onLogin={handleLogin} error={loginError} />
  )
) : (
  <div className="h-screen overflow-hidden relative">
    <BackgroundMedia
      key={`bg-${themeSettings.background?.type}-${themeSettings.background?.data?.substring(0, 50)}`}
      background={themeSettings.background}
    />
    {(() => {
      // v5: si média du haut masqué → header réduit à une fine bande (garde les
      // points cachés admin/plein écran), menu étendu à quasi plein écran.
      // v5: si média du haut masqué → header réduit sur fond BLANC.
      //  - sans sélecteur de langue : une fine bande (juste les points cachés)
      //  - avec langues : une ligne pour les points + une ligne pour les drapeaux
      const COMPACT_HEADER_PX = isTranslationEnabled ? 92 : 44;
      const headerHeight = hideProfileMedia
        ? COMPACT_HEADER_PX
        : isMobile
        ? Math.round(window.innerHeight * 0.2)
        : Math.round(window.innerHeight * 0.3);
      const mainHeight = hideProfileMedia
        ? window.innerHeight - COMPACT_HEADER_PX
        : isMobile
        ? Math.round(window.innerHeight * 0.8)
        : Math.round(window.innerHeight * 0.7);
      const sidebarWidth = Math.max(Math.round(window.innerWidth * 0.2), 150);
      const cartWidth = Math.max(Math.round(window.innerWidth * 0.25), 200);
      const contentWidth = Math.max(Math.round(window.innerWidth * 0.55), 300);

      const hasActiveBackground = themeSettings.background &&
                                   themeSettings.background.type !== 'none' &&
                                   themeSettings.background.data;

      return (
        <div className="relative z-10">
          <header
            className="fixed top-0 left-0 right-0 z-5"
            style={{ height: `${headerHeight}px` }}
          >
            <div className="relative w-full h-full isolate">
              <button
                className="absolute top-4 left-4 z-[130] group p-1.5 rounded-full bg-black/20 hover:bg-black/25 transition-all duration-300"
                onClick={() => {
                  let clickCount = (window.fullscreenClickCount || 0) + 1;
                  window.fullscreenClickCount = clickCount;
                  clearTimeout(window.fullscreenClickTimeout);
                  window.fullscreenClickTimeout = setTimeout(
                    () => (window.fullscreenClickCount = 0),
                    1000
                  );
                  if (clickCount === 4) {
                    if (!isFullscreen)
                      document.documentElement
                        .requestFullscreen()
                        .catch((err) => console.error(err));
                    else
                      document.exitFullscreen().catch((err) => console.error(err));
                    window.fullscreenClickCount = 0;
                    setIsFullscreen(!isFullscreen);
                  }
                }}
                aria-label={t('Basculer plein écran')}
              >
                <div className="w-2 h-2 rounded-full bg-white/80 border border-gray-500/70 shadow-[0_0_3px_rgba(0,0,0,0.5)] transition-all duration-300 group-hover:w-3 group-hover:h-3 group-hover:bg-white group-hover:border-gray-600" />
              </button>
              <button
                className="absolute top-4 left-10 z-[130] group p-1.5 rounded-full bg-black/20 hover:bg-black/25 transition-all duration-300"
                onClick={() => {
                  let settingsClickCount = (window.settingsClickCount || 0) + 1;
                  window.settingsClickCount = settingsClickCount;
                  clearTimeout(window.settingsClickTimeout);
                  window.settingsClickTimeout = setTimeout(
                    () => (window.settingsClickCount = 0),
                    1000
                  );
                  if (settingsClickCount === 10) {
                    window.settingsClickCount = 0;
                    // Admin accessible par 10 clics (démo comprise : le visiteur peut
                    // voir les paramètres s'il veut). Pas de code demandé.
                    toggleAdmin();
                  }
                }}
                aria-label={t('Basculer mode admin')}
              >
                <div className="w-2 h-2 rounded-full bg-white/80 border border-gray-500/70 shadow-[0_0_3px_rgba(0,0,0,0.5)] transition-all duration-300 group-hover:w-3 group-hover:h-3 group-hover:bg-white group-hover:border-gray-600" />
              </button>

              {hideProfileMedia ? (
                // v5: média masqué → fond BLANC (pas de bande noire).
                // Les boutons cachés (admin ×10, plein écran ×4) + langues restent au-dessus.
                <div className="w-full h-full bg-white" />
              ) : isLoading ? (
                // v5 z-index: même en chargement, le média reste une couche de FOND
                // (absolute inset-0 z-0) pour que le logo/nom (z-30) ne soient jamais poussés.
                <div className="absolute inset-0 z-0 flex items-center justify-center bg-gray-100 rounded-t-2xl">
                  <div className="animate-pulse text-gray-500">{t('Chargement')}</div>
                </div>
              ) : profileSettings.profileMedia && profileSettings.profileMedia.length > 0 ? (
                // v5 z-index: le média est une couche de FOND (z-0) pour que le
                // logo/nom (z-30) passent toujours au-dessus, jamais cachés derrière.
                <div className="absolute inset-0 z-0">
                  <ProfileMedia
                    profileMedia={profileSettings.profileMedia}
                    mediaIsVideo={profileSettings.mediaIsVideo}
                    currentMediaIndex={currentMediaIndex}
                    setCurrentMediaIndex={setCurrentMediaIndex}
                  />
                </div>
              ) : (
                <div className="absolute inset-0 z-0 flex items-center justify-center bg-gray-100 rounded-t-2xl">
                  <PlaceholderSVG />
                </div>
              )}

              {!hideProfileMedia && (
                <div className="absolute inset-x-0 top-0 p-4 z-30">
                  <div className="container mx-auto px-4 flex justify-between items-start">
                  <div className="flex items-center gap-4 md:gap-6">
                    {headerLogo && profileSettings.logoPosition !== 'after' && (
                      <img
                        src={headerLogo}
                        alt="Logo"
                        className="h-24 md:h-36 w-auto object-contain select-none pointer-events-none animate-fade-in drop-shadow-[0_0_12px_rgba(255,165,0,0.8)]"
                        draggable="false"
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    )}
                    {headerName && (
                      <h1
                        className={`
                          text-2xl md:text-4xl font-bold tracking-tight
                          text-white
                          px-4 py-2
                          animate-fade-in
                          font-playfair
                          inline-block
                          text-wrap
                          max-h-24
                          drop-shadow-[0_0_12px_rgba(255,165,0,0.8)]
                          ${headerName.length > 25 ? 'text-xl md:text-3xl' : ''}
                        `}
                        // v5 perf : lueur néon FIXE (milieu de l'ancienne animation `neon`).
                        // Un text-shadow animé à l'infini repeignait le titre à chaque image.
                        style={{
                          textShadow:
                            '0 0 7px #fff, 0 0 15px #fff, 0 0 22px #ff9500, 0 0 30px #ff9500',
                        }}
                      >
                        {headerName}
                      </h1>
                    )}
                    {headerLogo && profileSettings.logoPosition === 'after' && (
                      <img
                        src={headerLogo}
                        alt="Logo"
                        className="h-24 md:h-36 w-auto object-contain select-none pointer-events-none animate-fade-in drop-shadow-[0_0_12px_rgba(255,165,0,0.8)]"
                        draggable="false"
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    )}
                  </div>
                </div>
              </div>
              )}

              {isTranslationEnabled && (
                <div className={`absolute z-30 flex gap-3 ${hideProfileMedia ? 'bottom-2 left-4' : 'bottom-4 left-4'}`}>
                  {['fr', 'en', 'es', 'de', 'ar'].map((lang) => {
                    const flagCode = lang === 'ar' ? 'TN' : lang === 'en' ? 'GB' : lang.toUpperCase();
                    return (
                      <button
                        key={lang}
                        onClick={() => changeLanguage(lang)}
                        className={`
                          relative p-1 rounded-full
                          ${i18n.language === lang ? 'ring-2 ring-orange-500' : 'ring-1 ring-transparent'}
                          transition-shadow duration-200 ease-in-out
                          active:scale-110
                          focus:outline-none focus:ring-2 focus:ring-orange-500
                        `}
                        aria-label={`Choisir ${lang}`}
                      >
                        <Flag
                          country={flagCode}
                          className="w-7 h-7 rounded-full object-cover"
                        />
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          </header>

          <main
            className={`fixed inset-x-0 bottom-0 flex ${
              isMobile ? 'flex-col' : 'flex-row'
            } transition-all duration-300 ease-in-out`}
            style={{ height: `${mainHeight}px`, top: `${headerHeight}px` }}
          >
            {isMobile && (
              <div className={`md:hidden w-full overflow-x-auto hide-scrollbar ${hasActiveBackground ? 'bg-white/90' : 'bg-white'} z-10 p-2`}>
                <div className="flex space-x-2 px-2">
                  {categories.length > 0 ? (
                    categories.map((category) => (
                      <button
                        key={category._id}
                        onClick={() => handleCategoryChange(category._id)}
                        className={`flex-shrink-0 touch-manipulation category-card group transition-all duration-300 ${
                          selectedCategory === category._id
                            ? 'ring-2 ring-orange-500 ring-offset-2'
                            : 'hover:ring-1 hover:ring-orange-300 hover:ring-offset-1'
                        }`}
                        aria-label={t('Sélectionner catégorie', { name: category.name[0] })}
                      >
                        <div className="w-[90px] flex flex-col items-center">
                          <h3 className="text-gray-900 text-sm font-medium tracking-wide mb-1 text-center">
                            {category.name[0]}
                          </h3>
                          <div className="relative aspect-[3/2] rounded-xl overflow-hidden">
                            {categoryImages[category._id] ? (
                              <img
                                src={categoryImages[category._id]}
                                alt={category.name[0]}
                                className="w-full h-full object-cover transition-transform duration-300"
                                loading="lazy"
                                onError={(e) => {
                                  const target = e.currentTarget;
                                  target.style.display = 'none';
                                  if (target.nextSibling)
                                    (target.nextSibling as HTMLElement).style.display = 'flex';
                                }}
                              />
                            ) : category.image_url ? (
                              <img
                                src={cacheImage(
                                  `https://api.restomi.fr/${category.image_url}`,
                                  category._id,
                                  'category'
                                )}
                                alt={category.name[0]}
                                className="w-full h-full object-cover transition-transform duration-300"
                                loading="lazy"
                                onError={(e) => {
                                  const target = e.currentTarget;
                                  target.style.display = 'none';
                                  if (target.nextSibling)
                                    (target.nextSibling as HTMLElement).style.display = 'flex';
                                }}
                              />
                            ) : (
                              <div
                                className="w-full h-full flex items-center justify-center bg-gray-100 rounded-xl"
                                style={{ display: 'flex' }}
                              >
                                <PlaceholderSVG />
                              </div>
                            )}
                          </div>
                          {selectedCategory === category._id && (
                            <div className="absolute -bottom-0.5 left-1/2 transform -translate-x-1/2 w-3 h-0.5 bg-orange-500 rounded-full" />
                          )}
                        </div>
                      </button>
                    ))
                  ) : (
                    <div className="text-center text-gray-500 p-2">
                      {t('Aucune catégorie disponible')}
                    </div>
                  )}
                </div>
              </div>
            )}

            {!isMobile && (
              <div
                className="relative"
                style={{ width: `${sidebarWidth}px` }}
              >
                <aside
                  ref={categoriesScrollRef}
                  className={`block w-full h-full overflow-y-auto hide-scrollbar ${hasActiveBackground ? 'bg-white/90' : 'bg-white'}`}
                >
                <div className="p-4 space-y-4">
                  {(() => {
                    if (isLoading) {
                      return Array.from({ length: 4 }).map((_, index) => (
                        <div key={index} className="animate-pulse">
                          <div className="aspect-[4/3] bg-gray-200 rounded-xl mb-2"></div>
                          <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                        </div>
                      ));
                    }
                    if (error) {
                      return (
                        <div className="text-center py-8">
                          <div className="text-red-500 mb-2">{error}</div>
                          <button
                            onClick={fetchCategories}
                            className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
                          >
                            {t('Réessayer')}
                          </button>
                        </div>
                      );
                    }
                    if (categories.length === 0) {
                      return (
                        <div className="text-center py-8 text-gray-500">
                          {t('Aucune catégorie disponible')}
                        </div>
                      );
                    }
                    return categories.map((category) => (
                      <button
                        key={category._id}
                        onClick={() => handleCategoryChange(category._id)}
                        className={`group w-full touch-manipulation category-card transition-all duration-300 ${
                          selectedCategory === category._id
                            ? 'ring-2 ring-orange-500 ring-offset-2'
                            : 'hover:ring-1 hover:ring-orange-300 hover:ring-offset-1'
                        }`}
                        aria-label={t('Sélectionner catégorie', { name: category.name[0] })}
                      >
                        <div className="relative">
                          <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
                            {categoryImages[category._id] ? (
                              <img
                                src={categoryImages[category._id]}
                                alt={category.name[0]}
                                className="w-full h-full object-cover transition-transform duration-300"
                                loading="lazy"
                                onError={(e) => {
                                  const target = e.currentTarget;
                                  target.style.display = 'none';
                                  if (target.nextSibling)
                                    (target.nextSibling as HTMLElement).style.display = 'flex';
                                }}
                              />
                            ) : category.image_url ? (
                              <img
                                src={cacheImage(
                                  `https://api.restomi.fr/${category.image_url}`,
                                  category._id,
                                  'category'
                                )}
                                alt={category.name[0]}
                                className="w-full h-full object-cover transition-transform duration-300"
                                loading="lazy"
                                onError={(e) => {
                                  const target = e.currentTarget;
                                  target.style.display = 'none';
                                  if (target.nextSibling)
                                    (target.nextSibling as HTMLElement).style.display = 'flex';
                                }}
                              />
                            ) : (
                              <div
                                className="w-full h-full flex items-center justify-center bg-gray-100 rounded-xl"
                                style={{ display: 'flex' }}
                              >
                                <PlaceholderSVG />
                              </div>
                            )}
                            <div className="pointer-safe absolute inset-0 bg-gradient-to-t from-black/60 via-transparent opacity-100 transition-opacity" />
                          </div>
                          <div className="pointer-safe absolute inset-x-0 bottom-0 p-3 text-center">
                            <h3 className="text-white font-medium tracking-wide text-shadow-lg transform transition-transform duration-300">
                              {category.name[0]}
                            </h3>
                          </div>
                          {selectedCategory === category._id && (
                            <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-orange-500 rounded-full" />
                          )}
                        </div>
                      </button>
                    ));
                  })()}
                </div>
                </aside>
                <ScrollHint
                  targetRef={categoriesScrollRef}
                  config={scrollHintSettings.categories}
                />
              </div>
            )}

            <div
              className="relative flex-1"
              style={{ width: !isMobile ? `${contentWidth}px` : '100%' }}
            >
              <div
                ref={productsScrollRef}
                className={`block w-full h-full overflow-y-auto hide-scrollbar ${hasActiveBackground ? 'bg-transparent' : 'bg-gray-50'}`}
              >
              <div className="p-4">
                {renderedProducts.length === 0 && !isLoading && !error ? (
                  <div className="text-center py-8 text-gray-500">
                    {t('Aucun produit disponible')}
                    <button
                      onClick={() => handleCategoryChange(selectedCategory)}
                      className="mt-4 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600"
                    >
                      {t('Réessayer')}
                    </button>
                  </div>
                ) : (
                  <>
                    {/* v5 Happy Hour : bandeau en haut du menu si actif */}
                    {activeHappyHour && (
                      <HappyHourBanner
                        happyHour={activeHappyHour}
                        categories={categories || []}
                        onExpired={happyHourState.refresh}
                      />
                    )}
                    <div
                      className={`grid gap-4 justify-items-stretch ${
                        displayMode === 'mobile' || isMobile
                          ? 'grid-cols-1'
                          : displayMode === 'desktop-2'
                          ? 'grid-cols-2'
                          : 'grid-cols-3'
                      }`}
                    >
                    {renderedProducts
                      .filter((product) => product.is_item_in_stock)
                      .map((product) => (
                        <div
                          key={product._id}
                          className={`product-card touch-manipulation group relative ${hasActiveBackground ? 'bg-white/95' : 'bg-white'} rounded-2xl shadow-md overflow-hidden transition-transform duration-150 ease-out active:scale-[0.98] w-full h-full min-h-[400px] flex flex-col justify-between cursor-pointer`}
                          onClick={() => handleAddToCart(product)}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              handleAddToCart(product);
                            }
                          }}
                          aria-label={t('Ajouter au panier', { name: product.name[0] })}
                        >
                          <div className="relative h-60 overflow-hidden">
                            {productImages[product._id] ? (
                              <>
                                <img
                                  src={productImages[product._id]}
                                  alt={product.name[0]}
                                  className="w-full h-full object-cover transition-transform duration-700 ease-out"
                                  loading="lazy"
                                  style={{
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                    transform: 'scale(0.95)',
                                  }}
                                  onError={(e) => {
                                    const target = e.currentTarget;
                                    target.style.display = 'none';
                                    if (target.nextSibling)
                                      (target.nextSibling as HTMLElement).style.display = 'flex';
                                  }}
                                />
                                <div className="pointer-safe absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out" />
                              </>
                            ) : product.image_url[0] ? (
                              <>
                                <img
                                  src={cacheImage(
                                    `https://api.restomi.fr/${product.image_url[0]}`,
                                    product._id,
                                    'product'
                                  )}
                                  alt={product.name[0]}
                                  className="w-full h-full object-cover transition-transform duration-700 ease-out"
                                  loading="lazy"
                                  style={{
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                    transform: 'scale(0.95)',
                                  }}
                                  onError={(e) => {
                                    const target = e.currentTarget;
                                    target.style.display = 'none';
                                    if (target.nextSibling)
                                      (target.nextSibling as HTMLElement).style.display = 'flex';
                                  }}
                                />
                                <div className="pointer-safe absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out" />
                              </>
                            ) : (
                              <div
                                className="w-full h-full flex items-center justify-center bg-gray-100 rounded-t-2xl transition-transform duration-700 ease-out"
                                style={{ display: 'flex' }}
                              >
                                <div style={{ transform: 'scale(3)' }}>
                                  <PlaceholderSVG />
                                </div>
                                <div className="pointer-safe absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out" />
                              </div>
                            )}
                            {/* v5 Happy Hour : badge de remise sur la vignette */}
                            {activeHappyHour &&
                              isProductEligible(product._id, eligibleProductIds) && (
                                <div className="pointer-safe absolute top-3 left-3 bg-gradient-to-r from-orange-500 to-red-500 text-white text-sm font-extrabold px-2.5 py-1 rounded-full shadow-lg z-10">
                                  −{activeHappyHour.discount_percent}%
                                </div>
                              )}
                            <div className="pointer-safe absolute top-3 right-3 bg-green-500 text-white text-xs font-semibold px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                              {t('Disponible')}
                            </div>
                          </div>
                          <div className="p-5 flex flex-col justify-between flex-grow">
                            <div>
                              <h3 className="text-lg font-semibold text-gray-900 mb-2 whitespace-normal break-words transition-colors duration-300 group-hover:text-orange-600">
                                {product.name[0]}
                              </h3>
                              <p className="text-gray-500 text-sm mb-4 line-clamp-3 min-h-[4rem]">
                                {product.details[0]}
                              </p>
                            </div>
                            <div className="flex flex-col items-center gap-3">
                              {(() => {
                                // v5 Happy Hour : prix barré + prix remisé (INDICATIF).
                                // Le montant officiel vient du serveur (apply_happy_hour).
                                const hhEligible =
                                  activeHappyHour &&
                                  isProductEligible(product._id, eligibleProductIds);
                                if (!hhEligible) {
                                  return (
                                    <span className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent transition-transform duration-300">
                                      {product.price.toFixed(2)} {currency}
                                    </span>
                                  );
                                }
                                const discounted = getDiscountedPrice(
                                  product.price,
                                  activeHappyHour.discount_percent
                                );
                                return (
                                  <div className="flex items-center justify-center gap-2 flex-wrap">
                                    <span className="text-lg font-semibold text-gray-400 line-through">
                                      {product.price.toFixed(2)} {currency}
                                    </span>
                                    <span className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent">
                                      {discounted.toFixed(2)} {currency}
                                    </span>
                                  </div>
                                );
                              })()}
                              {(() => {
                                const cartItem = cartItems.find(
                                  (item) => item.productId === product._id && !item.subProducts?.length && Object.keys(item.specifications || {}).length === 0
                                );
                                return cartItem ? (
                                  <div className="w-full flex items-center justify-center gap-4 py-2.5" onClick={(e) => e.stopPropagation()}>
                                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-lg">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleUpdateQuantity(cartItem.uniqueId, cartItem.quantity - 1);
                                        }}
                                        className="w-8 h-8 flex items-center justify-center rounded-full bg-orange-100 text-orange-600 hover:bg-orange-200 transition-colors"
                                      >
                                        <Minus size={16} />
                                      </button>
                                    </div>
                                    <span className="font-bold text-xl text-gray-800 min-w-[32px] text-center">{cartItem.quantity}</span>
                                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-lg">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleUpdateQuantity(cartItem.uniqueId, cartItem.quantity + 1);
                                        }}
                                        className="w-8 h-8 flex items-center justify-center rounded-full bg-orange-100 text-orange-600 hover:bg-orange-200 transition-colors"
                                      >
                                        <Plus size={16} />
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <button
                                    className="relative w-full py-2.5 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg font-medium text-sm overflow-hidden transition-all duration-500 group"
                                    disabled={!product.is_item_in_stock}
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleAddToCart(product);
                                    }}
                                  >
                                    <span className="pointer-safe absolute inset-0 bg-gradient-to-r from-orange-600 to-red-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                                    <span className="relative flex items-center justify-center gap-2">
                                      <ShoppingCart
                                        size={18}
                                        className="transition-transform duration-300"
                                      />
                                      {t('Ajouter au panier')}
                                    </span>
                                  </button>
                                );
                              })()}
                            </div>
                          </div>
                          <div className="absolute inset-0 border-2 border-transparent group-hover:border-orange-500/30 rounded-2xl transition-all duration-500 ease-out pointer-events-none" />
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
              </div>
              <ScrollHint
                targetRef={productsScrollRef}
                config={scrollHintSettings.products}
              />
            </div>

            {!isMobile && (
              <div
                className="relative"
                style={{ width: `${cartWidth}px` }}
              >
                <aside
                  ref={cartScrollRef}
                  className={`block w-full h-full overflow-y-auto hide-scrollbar ${hasActiveBackground ? 'bg-white/85' : 'bg-gray-50'} transition-all duration-300 ease-in-out`}
                >
                  <div className="pr-4 pl-2 py-4">
                    <Cart
                      items={cartItems}
                      categories={categories}
                      onUpdateQuantity={handleUpdateQuantity}
                      onRemoveItem={handleRemoveItem}
                      onEditItem={handleEditCartItem}
                      onCheckout={handleCheckout}
                      printSettings={printSettings}
                      currency={currency}
                      isWarningActive={isWarningActive}
                      warningCountdown={warningCountdown}
                      onRushRejected={handleRushRejection}
                      happyHourEligibleAmount={happyHourEligibleAmount}
                      onModuleDisabled={handleModuleDisabled}
                    />
                  </div>
                </aside>
                {/* Position 140px du bas pour passer au-dessus du footer "Total + Commander" */}
                <ScrollHint
                  targetRef={cartScrollRef}
                  config={scrollHintSettings.cart}
                  bottomOffset={140}
                />
              </div>
            )}
          </main>

          {isMobile && (
            <>
              <button
                onClick={() => setShowCart(!showCart)}
                className="fixed bottom-4 right-4 bg-orange-500 text-white p-3 rounded-full shadow-lg hover:bg-orange-600 transition-colors z-50"
                style={{ width: '60px', height: '60px' }}
                aria-label={showCart ? t('Fermer le panier') : t('Ouvrir le panier')}
              >
                {cartItems.length > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium">
                    {cartItems.length}
                  </span>
                )}
                <ShoppingCart size={24} />
              </button>

              {showCart && (
                <div
                  className={`fixed inset-0 ${hasActiveBackground ? 'bg-white/95' : 'bg-white'} p-4 z-50 overflow-y-auto transition-opacity duration-300 ease-in-out`}
                  style={{ top: `${headerHeight}px` }}
                >
                  <div className="flex items-center justify-end space-x-2">
                    <button
                      onClick={() => setShowCart(false)}
                      className="p-2 text-gray-600 hover:text-gray-800 rounded-full hover:bg-gray-100 transition-colors z-60 flex items-center space-x-2"
                      aria-label={t('Fermer le panier')}
                    >
                      <ShoppingCart size={20} />
                      {cartItems.length > 0 && (
                        <span className="bg-red-500 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs font-medium">
                          {cartItems.length}
                        </span>
                      )}
                      <X size={20} />
                    </button>
                  </div>
                  <Cart
                    items={cartItems}
                    categories={categories}
                    onUpdateQuantity={handleUpdateQuantity}
                    onRemoveItem={handleRemoveItem}
                    onEditItem={handleEditCartItem}
                    onCheckout={handleCheckout}
                    printSettings={printSettings}
                    currency={currency}
                    isWarningActive={isWarningActive}
                    warningCountdown={warningCountdown}
                    onRushRejected={handleRushRejection}
                      happyHourEligibleAmount={happyHourEligibleAmount}
                      onModuleDisabled={handleModuleDisabled}
                  />
                </div>
              )}
            </>
          )}



{
  showSpecifications && selectedProduct && (() => {
    // v5: helpers de design
    const sd = specPopupDesign;
    const useCustom = sd.enabled;
    const radius = useCustom ? SPEC_RADIUS[sd.popupRadius] : 'rounded-2xl';
    const animClass = useCustom ? SPEC_ENTER_ANIM[sd.enterAnimation] : '';
    const popupBg = useCustom
      ? { background: `linear-gradient(135deg, ${sd.bgColor1} 0%, ${sd.bgColor2} 100%)` }
      : undefined;
    const isLight = useCustom ? isLightColorSpec(sd.bgColor1) : true;
    const textCol = useCustom ? sd.textColor : '#1f2937';
    const accentCol = useCustom ? sd.accentColor : '#f97316';
    // Overlays pour les boutons et zones secondaires
    const subtleOverlayBg = isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.1)';
    const subtleOverlayBorder = isLight ? 'rgba(0,0,0,0.12)' : 'rgba(255,255,255,0.2)';

    return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div
        className={`${useCustom ? '' : 'bg-white'} ${radius} w-full max-w-2xl overflow-hidden shadow-2xl p-6 relative ${animClass}`}
        style={popupBg}
      >
        {/* v5: image de fond optionnelle */}
        {useCustom && sd.backgroundImage && (
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              backgroundImage: `url(${sd.backgroundImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: sd.backgroundOpacity / 100,
              filter: sd.backgroundBlur > 0 ? `blur(${sd.backgroundBlur}px)` : undefined,
            }}
          />
        )}
        {/* Tout le contenu doit être au-dessus de l'image */}
        <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold" style={useCustom ? { color: textCol } : { color: '#1f2937' }}>
            {t('Personnalisez votre', { name: selectedProduct.name[0] || t('Produit', 'Produit') })}
          </h3>
          <button
            onClick={() => {
              setShowSpecifications(false);
              setSelectedProduct(null);
              setCurrentSpecificationIndex(0);
              setEditingCartItemId(null);
              Object.values(lottieRefs.current).forEach((anim) => anim?.destroy());
              lottieRefs.current = {};
            }}
            className="p-2 rounded-full transition-colors focus:outline-none active:scale-95 touch-manipulation"
            style={useCustom ? {
              color: textCol,
              backgroundColor: 'transparent',
            } : undefined}
            onMouseEnter={(e) => {
              if (useCustom) e.currentTarget.style.backgroundColor = subtleOverlayBg;
            }}
            onMouseLeave={(e) => {
              if (useCustom) e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <X size={20} className={useCustom ? '' : 'text-gray-400 hover:text-gray-600'} />
          </button>
        </div>

        {(() => {
          const cacheKey = `products:${selectedCategory}`;
          const cachedProducts = productsCache[cacheKey] || [];
          const cacheMode = localStorage.getItem('cacheMode') || 'modified';
          const modifiedProducts =
            cacheMode === 'modified' ? applyClientSettings(cachedProducts) : cachedProducts;
          const modifiedProduct =
            modifiedProducts.find((p) => p._id === selectedProduct._id) || selectedProduct;

          const visibleSpecs = modifiedProduct.specifications.filter(
            (spec) => specificationSettings[modifiedProduct._id]?.[spec._id]?.visible ?? true
          );
          if (visibleSpecs.length === 0) {
            return (
              <div className="text-center text-gray-500 py-4">
                {t('Aucune option disponible', 'Aucune option disponible')}
              </div>
            );
          }
          const spec = visibleSpecs[currentSpecificationIndex] || visibleSpecs[0];
          const selections = selectedSpecifications[spec._id] || [];
          const maxSelections = spec.type === 2 ? (spec.max_range > 0 ? spec.max_range : spec.range > 0 ? spec.range : 10) : 1;
          const minSelections = spec.is_required ? spec.range : 0;
          const currentSelections = selections.length;

          // Vérifier si une option exclusive (❌) est sélectionnée
          const hasExclusiveOptionSelected = selections.some((selectedId) => {
            const selectedOption = spec.list.find((opt) => opt._id === selectedId);
            return selectedOption ? isExclusiveOption(selectedOption.name?.[0] || '') : false;
          });

          // Fallback pour les messages si la traduction échoue
          const getMessage = (key, params, fallback) => {
            const message = t(key, params);
            if (message.includes('{count}') || message === key) {
              console.warn(`[Popup] Traduction échouée pour "${key}", utilisation du fallback: ${fallback}`);
              return fallback;
            }
            return message;
          };

          console.log(
            `[Popup] Spécification affichée pour ${spec.name[0]} (langue: ${i18n.language}) :`,
            {
              specId: spec._id,
              type: spec.type,
              range: spec.range,
              max_range: spec.max_range,
              is_required: spec.is_required,
              minSelections,
              maxSelections,
              currentSelections,
              translationKeys: {
                exact: getMessage('Sélectionnez exactement', { count: minSelections }, `Sélectionnez ${minSelections} option${minSelections !== 1 ? 's' : ''}`),
                upTo: getMessage('Sélectionnez jusqu’à', { count: maxSelections }, `Sélectionnez jusqu’à ${maxSelections} option${maxSelections !== 1 ? 's' : ''}`),
                counter: getMessage('Sélections compteur', { current: currentSelections, max: maxSelections }, `${currentSelections}/${maxSelections} sélectionnée${currentSelections !== 1 ? 's' : ''}`),
              },
              options: spec.list.map((opt) => ({
                id: opt._id,
                name: opt.name[0],
                price: opt.price,
                image: opt.image,
                animation: opt.animation ? 'Lottie' : null,
              })),
            }
          );

          return (
            <div className="space-y-6 max-h-[60vh] overflow-y-auto hide-scrollbar">
              <div className="mb-6">
                <div className="flex items-center justify-between mb-2">
                  <span
                    className="text-sm font-medium"
                    style={useCustom ? { color: textCol, opacity: 0.7 } : undefined}
                  >
                    {t('Étape', { current: currentSpecificationIndex + 1, total: visibleSpecs.length }, `Étape ${currentSpecificationIndex + 1} sur ${visibleSpecs.length}`)}
                  </span>
                  <span
                    className={`text-sm font-medium ${useCustom ? '' : 'text-orange-500'}`}
                    style={useCustom ? { color: accentCol } : undefined}
                  >
                    {Math.round(((currentSpecificationIndex + 1) / visibleSpecs.length) * 100)}%
                  </span>
                </div>
                <div
                  className={`w-full rounded-full h-2 ${useCustom ? '' : 'bg-gray-200'}`}
                  style={useCustom ? { backgroundColor: subtleOverlayBg } : undefined}
                >
                  <div
                    className={`h-2 rounded-full transition-all duration-300 ${useCustom ? '' : 'bg-orange-500'}`}
                    style={{
                      width: `${((currentSpecificationIndex + 1) / visibleSpecs.length) * 100}%`,
                      ...(useCustom ? { backgroundColor: accentCol } : {}),
                    }}
                  ></div>
                </div>
              </div>

              <div key={spec._id} className="space-y-3">
                <div className="flex items-center justify-between">
                  <div>
                    <label className="font-medium text-gray-700">
                      {spec.name[0] || t('Option', 'Option')}
                      {spec.is_required && <span className="text-red-500 ml-1">*</span>}
                    </label>
                    <div
                      className={`flex items-center gap-2 text-gray-600 font-medium text-sm mt-1 ${
                        specError === spec._id && isVibrating ? 'animate-vibrate text-red-600' : ''
                      }`}
                    >
                      <svg
                        className={`w-4 h-4 ${specError === spec._id ? 'text-red-600' : 'text-gray-400'}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 9v2m0 4h.01M12 17h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <span>
                        {hasExclusiveOptionSelected
                          ? t('Option exclusive sélectionnée', 'Option exclusive sélectionnée - Vous pouvez continuer')
                          : spec.is_required && minSelections > 0
                          ? getMessage('Sélectionnez exactement', { count: minSelections }, `Sélectionnez ${minSelections} option${minSelections !== 1 ? 's' : ''}`)
                          : getMessage('Sélectionnez jusqu\'à', { count: maxSelections }, `Sélectionnez jusqu\'à ${maxSelections} option${maxSelections !== 1 ? 's' : ''}`)}
                      </span>
                    </div>
                    {spec.is_required && !selections.length && (
                      <div
                        className="flex items-center gap-2 p-2 rounded-lg text-amber-600 bg-amber-50 font-medium text-sm mt-1"
                      >
                        <svg
                          className="w-4 h-4 text-amber-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01M12 17h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <span>{t('Option requise', 'Option obligatoire')}</span>
                      </div>
                    )}
                  </div>
                  {spec.type === 2 && maxSelections > 0 && !hasExclusiveOptionSelected && (
                    <span
                      className={`text-sm font-medium px-2 py-1 rounded-full ${
                        currentSelections >= maxSelections
                          ? 'bg-green-100 text-green-800'
                          : 'bg-gray-100 text-gray-800'
                      }`}
                    >
                      {getMessage('Sélections compteur', { current: currentSelections, max: maxSelections }, `${currentSelections}/${maxSelections} sélectionnée${currentSelections !== 1 ? 's' : ''}`)}
                    </span>
                  )}
                  {hasExclusiveOptionSelected && (
                    <span className="text-sm font-medium px-2 py-1 rounded-full bg-green-100 text-green-800">
                      {t('Option complète', 'Sélection complète')} ✓
                    </span>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {spec.list
                    .filter(
                      (option) =>
                        subproductSettings[modifiedProduct._id]?.[option.name?.[0]]?.visible ?? true
                    )
                    .map((option) => {
                      const optionQuantity = selections.filter((id) => id === option._id).length;
                      const isSelected = optionQuantity > 0;

                      // Vérifier si cette option est exclusive (se termine par ❌)
                      const isCurrentExclusive = isExclusiveOption(option.name?.[0] || '');

                      // Vérifier si une option exclusive est déjà sélectionnée
                      const hasExclusiveSelected = selections.some((selectedId) => {
                        const selectedOption = spec.list.find((opt) => opt._id === selectedId);
                        return selectedOption ? isExclusiveOption(selectedOption.name?.[0] || '') : false;
                      });

                      // Vérifier si des options normales sont sélectionnées
                      const hasNormalSelected = selections.some((selectedId) => {
                        const selectedOption = spec.list.find((opt) => opt._id === selectedId);
                        return selectedOption ? !isExclusiveOption(selectedOption.name?.[0] || '') : false;
                      });

                      // Logique d'exclusion mutuelle
                      let canSelectBasedOnExclusion = true;
                      if (spec.type === 2) {
                        // Si l'option courante est normale et qu'une option exclusive est sélectionnée
                        if (!isCurrentExclusive && hasExclusiveSelected && !isSelected) {
                          canSelectBasedOnExclusion = false;
                        }
                        // Si l'option courante est exclusive et que des options normales sont sélectionnées
                        // On permet quand même le clic (car ça va vider les autres)
                        // Mais on peut l'indiquer visuellement si nécessaire
                      }

                      const canSelect =
                        spec.type === 2
                          ? canSelectBasedOnExclusion && (maxSelections === 0 || currentSelections < maxSelections || (isSelected && !spec.user_can_add_specification_quantity))
                          : true;
                      const imageKey = `${modifiedProduct._id}:${option.name?.[0]}`;
                      const optionPrice = subproductSettings[modifiedProduct._id]?.[option.name?.[0]]?.price ?? option.price;

                      return (
                        <div
                          key={option._id}
                          onClick={() =>
                            canSelect && handleSpecificationChange(spec._id, option._id)
                          }
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if ((e.key === 'Enter' || e.key === ' ') && canSelect) {
                              e.preventDefault();
                              handleSpecificationChange(spec._id, option._id);
                            }
                          }}
                          className={`p-3 rounded-xl border-2 transition-all cursor-pointer touch-manipulation ${
                            useCustom
                              ? ''
                              : isSelected
                              ? 'border-orange-500 bg-orange-50 shadow-orange-100'
                              : canSelect
                              ? 'border-gray-200 hover:border-orange-200 active:scale-98'
                              : 'border-gray-100 bg-gray-50 opacity-50 cursor-not-allowed'
                          } ${!canSelect && !isSelected ? 'pointer-events-none' : ''}`}
                          style={useCustom ? (() => {
                            const opt = getOptionButtonStyles(sd.bgColor1, sd.accentColor, isSelected);
                            return {
                              borderColor: opt.border,
                              backgroundColor: opt.background,
                              color: opt.color,
                              opacity: !canSelect && !isSelected ? 0.5 : 1,
                              cursor: !canSelect && !isSelected ? 'not-allowed' : 'pointer',
                            };
                          })() : undefined}
                        >
                          <div className="w-full flex items-center gap-2 pointer-events-none">
                            {option.animation ? (
                              <div
                                className="w-20 h-20 pointer-events-none"
                                ref={(el) => {
                                  if (el && !lottieRefs.current[imageKey]) {
                                    lottieRefs.current[imageKey] = Lottie.loadAnimation({
                                      container: el,
                                      animationData: JSON.parse(option.animation),
                                      renderer: 'svg',
                                      loop: true,
                                      autoplay: !document.hidden && showSpecifications,
                                    });
                                  }
                                }}
                              />
                            ) : (option.image || subproductImages[imageKey]) ? (
                              <img
                                src={option.image || subproductImages[imageKey]}
                                alt={option.name?.[0]}
                                className="w-20 h-20 object-cover rounded-md"
                                onError={(e) => {
                                  e.currentTarget.style.display = 'none';
                                  console.error('Erreur chargement image:', option.name?.[0]);
                                }}
                              />
                            ) : null}
                            <div className="flex-1 text-left">
                              <div className="font-medium text-gray-800">
                                {option.name?.[0] || t('Option', 'Option')}
                              </div>
                              {optionPrice > 0 && (
                                <div className="text-sm text-orange-600 mt-1">
                                  +{optionPrice.toFixed(2)} {currency}
                                  {spec.user_can_add_specification_quantity && optionQuantity > 1 && (
                                    <span className="ml-1 text-gray-500">
                                      (x{optionQuantity} = {(optionPrice * optionQuantity).toFixed(2)} {currency})
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                          {spec.user_can_add_specification_quantity && isSelected && (
                            <div className="flex items-center justify-center gap-4 mt-2 pt-2 border-t border-orange-200 pointer-events-none">
                              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-lg">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSpecificationDecrease(spec._id, option._id);
                                  }}
                                  className="w-8 h-8 flex items-center justify-center rounded-full bg-orange-100 text-orange-600 hover:bg-orange-200 transition-colors focus:outline-none active:scale-95 touch-manipulation pointer-events-auto"
                                >
                                  <Minus size={16} />
                                </button>
                              </div>
                              <span className="font-bold text-lg text-gray-800 min-w-[28px] text-center">
                                {optionQuantity}
                              </span>
                              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-lg">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (currentSelections < maxSelections) {
                                      handleSpecificationChange(spec._id, option._id, true);
                                    }
                                  }}
                                  disabled={currentSelections >= maxSelections}
                                  className={`w-8 h-8 flex items-center justify-center rounded-full transition-colors focus:outline-none active:scale-95 touch-manipulation pointer-events-auto ${
                                    currentSelections >= maxSelections
                                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                      : 'bg-orange-100 text-orange-600 hover:bg-orange-200'
                                  }`}
                                >
                                  <Plus size={16} />
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>

              <div
                className="flex gap-3 mt-6 pt-6"
                style={useCustom ? { borderTop: `1px solid ${subtleOverlayBorder}` } : { borderTop: '1px solid #e5e7eb' }}
              >
                <button
                  onClick={() => {
                    setShowSpecifications(false);
                    setSelectedProduct(null);
                    setCurrentSpecificationIndex(0);
                    setEditingCartItemId(null);
                    Object.values(lottieRefs.current).forEach((anim) => anim?.destroy());
                    lottieRefs.current = {};
                  }}
                  className={`px-4 py-3 rounded-xl transition-colors focus:outline-none active:scale-98 touch-manipulation ${
                    useCustom ? '' : 'text-gray-700 bg-gray-100 hover:bg-gray-200'
                  }`}
                  style={useCustom ? {
                    color: textCol,
                    backgroundColor: subtleOverlayBg,
                  } : undefined}
                >
                  {t('Annuler', 'Annuler')}
                </button>

                <div className="flex-1 flex gap-2">
                  {currentSpecificationIndex > 0 && (
                    <button
                      onClick={handlePreviousSpecification}
                      className={`flex-1 px-4 py-3 rounded-xl transition-colors flex items-center justify-center gap-2 focus:outline-none active:scale-98 touch-manipulation ${
                        useCustom ? '' : 'text-orange-500 bg-orange-50 hover:bg-orange-100'
                      }`}
                      style={useCustom ? {
                        color: accentCol,
                        backgroundColor: isLightColorSpec(accentCol)
                          ? `${accentCol}22`
                          : `${accentCol}33`,
                      } : undefined}
                    >
                      <ArrowLeft size={18} />
                      <span>{t('Précédent', 'Précédent')}</span>
                    </button>
                  )}

                  <button
                    onClick={handleNextSpecification}
                    className={`flex-1 px-4 py-3 rounded-xl transition-colors flex items-center justify-center gap-2 focus:outline-none active:scale-98 touch-manipulation ${
                      useCustom ? '' : 'text-white bg-orange-500 hover:bg-orange-600'
                    }`}
                    style={useCustom ? {
                      backgroundColor: accentCol,
                      color: isLightColorSpec(accentCol) ? '#1f2937' : '#ffffff',
                    } : undefined}
                  >
                    {currentSpecificationIndex < visibleSpecs.length - 1 ? (
                      <>
                        <span>{t('Suivant', 'Suivant')}</span>
                        <ArrowRight size={18} />
                      </>
                    ) : (
                      <span>{t('Ajouter au panier', 'Ajouter au panier')}</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}
        </div>
      </div>
    </div>
    );
  })()
}

          <ModernNotification
            title={notification.title}
            message={notification.message}
            type={notification.type}
            isOpen={notification.isOpen}
            onClose={notification.hideNotification}
            duration={notification.duration}
            actions={notification.actions}
          />
        </div>
      );
    })()}
  </div>
)}
</div>
      )}
    </WrappedAppErrorBoundary>
  );
}



/* v5 perf — cache des traductions (`translated_<langue>_<hash>` dans localStorage).
 * Il grossissait sans limite : chaque modification du menu créait de nouvelles clés,
 * jusqu'à remplir le quota (~5 Mo) et faire échouer TOUTES les sauvegardes localStorage.
 * On purge ces traductions (et seulement elles) quand le quota est atteint, ou au
 * démarrage si elles sont trop nombreuses. Une traduction purgée est simplement
 * redemandée une fois. */
const TRANSLATION_CACHE_PREFIX = 'translated_';
const TRANSLATION_CACHE_MAX_KEYS = 3000;

const purgeTranslationCache = (): number => {
  const keys: string[] = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(TRANSLATION_CACHE_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => localStorage.removeItem(k));
  } catch {
    /* stockage indisponible : rien à faire */
  }
  return keys.length;
};

const setTranslationCacheEntry = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Quota atteint : on libère les anciennes traductions puis on réessaie une fois.
    const purged = purgeTranslationCache();
    console.warn(`[translationCache] Stockage plein : ${purged} traductions purgées`);
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('[translationCache] Sauvegarde impossible:', error);
    }
  }
};

try {
  let count = 0;
  for (let i = 0; i < localStorage.length; i++) {
    if (localStorage.key(i)?.startsWith(TRANSLATION_CACHE_PREFIX)) count++;
  }
  if (count > TRANSLATION_CACHE_MAX_KEYS) {
    console.warn(`[translationCache] ${count} traductions en cache → purge au démarrage`);
    purgeTranslationCache();
  }
} catch {
  /* stockage indisponible */
}

export default App;  
